/**
 * Workshop Booking (Liquid-first + minimal JS)
 *
 * - Liquid renders the BASE POOL (product match + status active/sold_out)
 * - JS only does UI refresh: State -> City -> Variant filtering on already-rendered cards
 * - Keeps event_id deep-link in URL while preserving other query params
 *
 * Add-to-cart: JSON (items array). Cart Transform: _workshop, _resolved_price*.
 *
 * Diagnostics: window.__WB_DIAG__=true for [WB_DIAG] and [WB_PERF] logs.
 * WB_PERF format: [WB_PERF] cycle=<id> req=<id> step=<step> ms=<int> extra=<json>. Correlate with backend via extra.rid when data.meta.debug.rid is present.
 */

/**
 * window.__WB_INITIAL_EVENT_ID__ is set by a Liquid <script> snippet in the product template
 * BEFORE theme.js loads. Theme's _updateHistoryState strips event_id from the URL via
 * history.replaceState during variant init — by the time our script runs, it's already gone.
 * The Liquid snippet reads it server-side and passes it here as a global.
 * Fallback: try URL now in case Liquid snippet is missing.
 */
if (!window.__WB_INITIAL_EVENT_ID__) {
  try {
    var _wbEid = new URLSearchParams(window.location.search).get('event_id');
    if (_wbEid) {
      window.__WB_INITIAL_EVENT_ID__ = _wbEid.trim();
      if (window.__WB_DIAG__) console.log('[WB_RESTORE] event_id from URL fallback:', window.__WB_INITIAL_EVENT_ID__);
    }
  } catch (e) {}
}

function wbUrlHasWizardDeepLink() {
  if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') return true;
  try {
    var p = new URLSearchParams(window.location.search);
    return !!((p.get('venue') || '').trim() || (p.get('event_id') || '').trim());
  } catch (_) {
    return false;
  }
}

/** Waitlist POST (adapter). Legacy — prefer Connect Forms via wbDispatchAogenBookingContext. */
var __WB_WAITLIST_API_URL__ =
  typeof window.__WB_WAITLIST_API_URL__ === 'string' && window.__WB_WAITLIST_API_URL__.trim()
    ? window.__WB_WAITLIST_API_URL__.trim()
    : 'https://adapter.aogen.com.au/api/public/waitlist';

/** Connect Forms public API base (no trailing slash). */
var __WB_FORMS_API_BASE__ =
  typeof window.__WB_FORMS_API_BASE__ === 'string' && window.__WB_FORMS_API_BASE__.trim()
    ? window.__WB_FORMS_API_BASE__.trim().replace(/\/+$/, '')
    : 'https://adapter.aogen.com.au';

var __WB_FORMS_FORM_KEY__ =
  typeof window.__WB_FORMS_FORM_KEY__ === 'string' && window.__WB_FORMS_FORM_KEY__.trim()
    ? window.__WB_FORMS_FORM_KEY__.trim()
    : 'waitlist';

function wbParseCityStateFromCityKey(cityKey) {
  var parts = String(cityKey || '')
    .trim()
    .toLowerCase()
    .split('-')
    .filter(Boolean);
  var city = parts.length >= 3 ? parts.slice(2).join(' ') : '';
  var state = parts.length >= 2 && /^[a-z]{2}$/.test(parts[1]) ? parts[1].toUpperCase() : '';
  if (city) {
    city = city.replace(/\b\w/g, function (ch) {
      return ch.toUpperCase();
    });
  }
  return { city: city, state: state };
}

function wbResolveWorkshopTypeFromBookingRoot(bookingRoot) {
  var workshopType = '';
  try {
    if (bookingRoot && bookingRoot.getAttribute) {
      workshopType = bookingRoot.getAttribute('data-workshop-type') || '';
    }
    if (!String(workshopType || '').trim()) {
      var typeEl = document.querySelector('[data-workshop-type]');
      workshopType = typeEl ? typeEl.getAttribute('data-workshop-type') || '' : '';
    }
  } catch (_) {
    workshopType = '';
  }
  return String(workshopType || '').trim().toLowerCase();
}

/**
 * Build Connect Forms booking-context snapshot from wizard/location venue state.
 * Theme fires once on waitlist open (popup) or datetime step enter (inline).
 */
function wbBuildAogenBookingContext(venue, bookingRoot, opts) {
  opts = opts || {};
  venue = venue && typeof venue === 'object' ? venue : {};
  var venueRefId = venue.venue_ref_id != null ? String(venue.venue_ref_id).trim() : '';
  if (!venueRefId && venue.venue_id != null) venueRefId = String(venue.venue_id).trim();
  var venueName = String(venue.venue_name || venue.name || '').trim();
  var parsed = wbParseCityStateFromCityKey(venue.city_key || '');
  var city = String(venue.city || venue.city_name || parsed.city || '').trim();
  var state = String(venue.state || venue.state_code || venue.region_code || parsed.state || '').trim();
  if (!city && venueName) city = venueName;
  var productId = bookingRoot && bookingRoot.getAttribute ? String(bookingRoot.getAttribute('data-product-id') || '').trim() : '';
  var productName = bookingRoot && bookingRoot.getAttribute ? String(bookingRoot.getAttribute('data-product-name') || '').trim() : '';
  var productHandle = bookingRoot && bookingRoot.getAttribute ? String(bookingRoot.getAttribute('data-product-handle') || '').trim() : '';
  var country = String(opts.country || '').trim();
  if (!country && bookingRoot && bookingRoot.getAttribute) {
    country = String(bookingRoot.getAttribute('data-country') || '').trim();
  }
  if (!country) country = 'USA';
  return {
    form_key: __WB_FORMS_FORM_KEY__,
    intent: opts.intent === 'popup' ? 'popup' : 'inline',
    venue_id: venueRefId,
    venue_name: venueName,
    city: city,
    state: state,
    country: country,
    workshop_type: wbResolveWorkshopTypeFromBookingRoot(bookingRoot),
    product_id: productId,
    product_name: productName,
    product_handle: productHandle,
    available_event_dates: opts.available_event_dates ? String(opts.available_event_dates) : '',
  };
}

/** Waitlist Connect block only — never the PDP Group Form block. */
function wbFindWaitlistAogenBlock() {
  var blocks = document.querySelectorAll('.aogen-forms-block');
  for (var i = 0; i < blocks.length; i++) {
    var b = blocks[i];
    if (!b) continue;
    if (b.closest('[data-amc-group-form]')) continue;
    if (b.getAttribute('data-amc-group-form-block') === '1') continue;
    if (b.getAttribute('data-wbw-aogen-skip') === '1') continue;
    return b;
  }
  return null;
}

function wbDispatchAogenBookingContext(detail) {
  detail = detail || {};
  var wizard = document.querySelector('.wbw-root');
  var block = wbFindWaitlistAogenBlock();
  /* Place + popup class BEFORE Connect listeners run (forceOpen races otherwise). */
  if (detail.intent === 'popup' && block && wizard) {
    wbCloseNativeWaitlistModal();
    wizard.classList.add('wbw-root--aogen-popup-active');
    wizard.setAttribute('data-wbw-below-waitlist', '0');
    wizard.__wbBelowWaitlistCtxKey = '';
    var belowPanel = wizard.querySelector('[data-wbw-below-waitlist]');
    if (belowPanel) {
      belowPanel.hidden = true;
      belowPanel.setAttribute('aria-hidden', 'true');
    }
    wbClearBelowWaitlistWatch(wizard);
    wbStripBelowWaitlistPolish(block);
    wbPlaceAogenFormsBlock(wizard, block);
  } else if (detail.intent === 'inline' && wizard) {
    wizard.classList.remove('wbw-root--aogen-popup-active');
    if (block) wbPlaceAogenFormsBlock(wizard, block);
  }
  try {
    document.dispatchEvent(new CustomEvent('aogen:booking-context', { detail: detail }));
  } catch (_) {}
}

window.wbBuildAogenBookingContext = wbBuildAogenBookingContext;
window.wbDispatchAogenBookingContext = wbDispatchAogenBookingContext;
window.__WB_FORMS_API_BASE__ = __WB_FORMS_API_BASE__;
window.__WB_FORMS_FORM_KEY__ = __WB_FORMS_FORM_KEY__;

function wbAogenConnectFormsAvailable() {
  return !!wbFindWaitlistAogenBlock();
}

/** True when Connect runtime has mounted the waitlist block (safe to skip native modal). */
function wbAogenConnectFormsReady() {
  /* Do NOT treat __AOGEN_CONNECT_FORMS_WAITLIST_UI__ as ready — that flag is set
     when we commit to Connect UI, which used to short-circuit boot retries. */
  return wbAogenFormsBlockReady(wbFindWaitlistAogenBlock());
}

function wbCloseNativeWaitlistModal() {
  document.querySelectorAll('.wbw-wl-modal').forEach(function (modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
  });
  /* Legacy location.js modal (non-wizard) — keep closed when Connect is used. */
  document.querySelectorAll('.wb-waitlist-modal').forEach(function (modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
  });
}

function wbAogenFormsBlockReady(block) {
  if (!block) return false;
  return (
    block.getAttribute('data-aogen-ready') === '1' ||
    block.getAttribute('data-aogen-mounted') != null ||
    block.getAttribute('data-submit-bound') === '1'
  );
}

function wbSyncConnectWaitlistUi(wizard, block) {
  if (!wizard) return;
  /* Only hide native when Connect has actually mounted (or popup is actively open). */
  var ready = wbAogenFormsBlockReady(block);
  if (ready) window.__AOGEN_CONNECT_FORMS_WAITLIST_UI__ = true;
  var useConnect = ready || wizard.classList.contains('wbw-root--aogen-popup-active');
  wizard.classList.toggle('wbw-root--connect-waitlist', !!useConnect);
}

/** Open Connect waitlist popup; retries briefly if the block is still booting (common on mobile). */
function wbOpenAogenWaitlistPopup(venue, bookingRoot) {
  if (
    typeof window.wbBuildAogenBookingContext !== 'function' ||
    typeof window.wbDispatchAogenBookingContext !== 'function'
  ) {
    return false;
  }
  var block = wbFindWaitlistAogenBlock();
  if (!block) return false;

  function markConnectUiActive() {
    wbCloseNativeWaitlistModal();
    var wizard = document.querySelector('.wbw-root');
    if (wizard) {
      wizard.classList.add('wbw-root--connect-waitlist');
      window.__AOGEN_CONNECT_FORMS_WAITLIST_UI__ = true;
    }
  }

  function dispatch() {
    markConnectUiActive();
    window.wbDispatchAogenBookingContext(
      window.wbBuildAogenBookingContext(venue || {}, bookingRoot || null, { intent: 'popup' })
    );
  }

  function openNativeFallback() {
    var wizard = document.querySelector('.wbw-root');
    if (wizard) wizard.classList.remove('wbw-root--connect-waitlist');
    try {
      document.dispatchEvent(
        new CustomEvent('wbw:open-waitlist-modal', {
          detail: {
            bookingRoot: bookingRoot || null,
            venueRefId: (venue && (venue.venue_ref_id || venue.venue_id || '')) || '',
            venueName: (venue && (venue.venue_name || venue.name || '')) || '',
            forceNative: true,
          },
        })
      );
    } catch (_) {}
  }

  if (wbAogenFormsBlockReady(block)) {
    dispatch();
    return true;
  }

  if (window.__WB_AOGEN_WL_OPEN_TIMER__) {
    try {
      clearInterval(window.__WB_AOGEN_WL_OPEN_TIMER__);
    } catch (_) {}
  }
  var tries = 0;
  window.__WB_AOGEN_WL_OPEN_TIMER__ = setInterval(function () {
    tries += 1;
    var ready = wbAogenFormsBlockReady(wbFindWaitlistAogenBlock());
    if (ready || tries >= 25) {
      try {
        clearInterval(window.__WB_AOGEN_WL_OPEN_TIMER__);
      } catch (_) {}
      window.__WB_AOGEN_WL_OPEN_TIMER__ = 0;
      if (ready) dispatch();
      else openNativeFallback();
    }
  }, 120);
  /* Truthy: caller must not open native yet — we retry, then Connect or forceNative. */
  return true;
}

window.wbOpenAogenWaitlistPopup = wbOpenAogenWaitlistPopup;

function wbMarkAogenAppsSectionHidden(section) {
  if (!section) return;
  section.setAttribute('data-wbw-aogen-apps-hidden', '');
  section.setAttribute('hidden', '');
  section.setAttribute('aria-hidden', 'true');
  section.style.display = 'none';
}

function wbHideEmptyAogenAppsSection(block, appsSection) {
  var section = appsSection || (block && block.__wbAogenAppsSection);
  if (!section) return;
  /* Keep Apps shell hidden after relocating the waitlist block (avoids empty gap + FOUC). */
  if (!section.querySelector('.aogen-forms-block') || section.hasAttribute('data-wbw-aogen-apps-hidden')) {
    wbMarkAogenAppsSectionHidden(section);
  }
}

function wbEnsureAogenPopupHost() {
  var host = document.querySelector('[data-wbw-aogen-forms-popup-host]');
  if (host) return host;
  host = document.createElement('div');
  host.setAttribute('data-wbw-aogen-forms-popup-host', '');
  host.setAttribute('aria-hidden', 'true');
  document.body.appendChild(host);
  return host;
}

function wbSyncAogenPopupHostState(block) {
  var host = document.querySelector('[data-wbw-aogen-forms-popup-host]');
  if (!host || !block) return;
  var open = block.classList.contains('is-open');
  host.setAttribute('aria-hidden', open ? 'false' : 'true');
}

function wbBindAogenPopupCloseSync(wizard, block) {
  if (!wizard || !block || block.__wbAogenCloseBound) return;
  block.__wbAogenCloseBound = true;
  var mo = new MutationObserver(function () {
    wbSyncAogenPopupHostState(block);
    if (!block.classList.contains('is-open') && wizard.classList.contains('wbw-root--aogen-popup-active')) {
      wizard.classList.remove('wbw-root--aogen-popup-active');
      if (typeof window.wbSyncBelowWaitlistPanel === 'function') {
        window.wbSyncBelowWaitlistPanel({ wizard: wizard });
      }
    }
  });
  mo.observe(block, { attributes: true, attributeFilter: ['class'] });
}

function wbPlaceAogenFormsBlock(wizard, block) {
  if (!wizard || !block) return;
  if (
    block.closest('[data-amc-group-form]') ||
    block.getAttribute('data-amc-group-form-block') === '1' ||
    block.getAttribute('data-wbw-aogen-skip') === '1'
  ) {
    return;
  }
  var appsSection = block.closest('.shopify-section.section-apps');
  if (appsSection) {
    block.__wbAogenAppsSection = appsSection;
    wbMarkAogenAppsSectionHidden(appsSection);
  }
  var branch = wizard.getAttribute('data-wbw-branch') || '';
  var popupActive = wizard.classList.contains('wbw-root--aogen-popup-active');
  var belowMount = wizard.querySelector('[data-wbw-aogen-forms-mount="below"]');
  var waitlistMount = wizard.querySelector('[data-wbw-aogen-forms-mount="waitlist"]');
  var popupHost = wbEnsureAogenPopupHost();
  /*
   * Park Connect on the body host during venue search so its remount/fetch does not
   * compete with wizard boot. Move into the under-shell mount only on booking steps.
   * Avoid re-appending when already home (Connect remounts on childList add).
   */
  var mount = popupHost;
  if (belowMount && (branch === 'datetime' || branch === 'variants') && !popupActive) {
    mount = belowMount;
  } else if (waitlistMount && branch === 'waitlist') {
    mount = waitlistMount;
  }

  if (block.parentElement !== mount) mount.appendChild(block);
  if (!popupActive && mount === belowMount) wbRestoreAogenInlinePanel(block);

  wbSyncAogenPopupHostState(block);
  wbSyncConnectWaitlistUi(wizard, block);
  wbHideEmptyAogenAppsSection(block, block.__wbAogenAppsSection);
}

/**
 * After Connect popup/drawer, panel may sit in a hidden overlay with [hidden].
 * Pull it back into the block for the fixed under-shell card.
 * Never destroy Connect chrome (close/teaser) — CSS hides them in below mount.
 */
function wbRestoreAogenInlinePanel(block) {
  if (!block) return null;
  var wizard = document.querySelector('.wbw-root');
  if (wizard && wizard.classList.contains('wbw-root--aogen-popup-active')) return null;
  var overlay = document.querySelector('.aogen-forms-overlay');
  if (overlay && overlay.classList.contains('is-open') && block.classList.contains('is-open')) {
    /* Active popup owns the panel — do not yank it. */
    return null;
  }
  var panel =
    block.querySelector('.aogen-forms-panel') ||
    (overlay && overlay.querySelector('.aogen-forms-panel')) ||
    null;
  if (panel && panel.parentElement !== block) {
    block.appendChild(panel);
  }
  if (panel) {
    panel.hidden = false;
    panel.removeAttribute('hidden');
    if (panel.style) {
      panel.style.transform = '';
      panel.style.left = '';
      panel.style.right = '';
      panel.style.top = '';
      panel.style.bottom = '';
      panel.style.inset = '';
    }
  }
  block.classList.remove('is-open', 'is-popup', 'is-drawer', 'is-floating');
  if (overlay) {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    overlay.setAttribute('hidden', '');
  }
  var teaser = document.querySelector('.aogen-forms-corner-teaser');
  if (teaser) teaser.hidden = true;
  return panel;
}

function wbVenueHasBookableEvents(venue) {
  if (!venue || typeof venue !== 'object') return false;
  try {
    if (
      window.WorkshopBookingVenueModel &&
      typeof window.WorkshopBookingVenueModel.venueHasBookableEvents === 'function'
    ) {
      return !!window.WorkshopBookingVenueModel.venueHasBookableEvents(venue);
    }
  } catch (_) {}
  if (venue.has_events === true) return true;
  if (venue._wbWaitlistVenue === true) return false;
  if (venue.next_date_key || Number(venue.events_count) > 0) return true;
  return Array.isArray(venue.events) && venue.events.length > 0;
}

/** Permanent store venues on this shop (Carrollton, Dallas, Orlando) — not popup. */
function wbIsStoreVenue(venue) {
  if (!venue || typeof venue !== 'object') return false;
  var parts = [
    venue.venue_name,
    venue.name,
    venue.city_name,
    venue.city,
    venue.venue_handle,
    venue.handle,
    venue.city_key,
  ];
  for (var i = 0; i < parts.length; i++) {
    var s = String(parts[i] || '')
      .trim()
      .toLowerCase();
    if (!s) continue;
    if (s === 'dallas' || s === 'carrollton' || s === 'orlando') return true;
    if (/(^|-)(dallas|carrollton|orlando)$/.test(s)) return true;
    if (/\b(dallas|carrollton|orlando)\b/.test(s)) return true;
  }
  return false;
}

function wbBelowWaitlistFormReady(block) {
  if (!block) return false;
  var panel = block.querySelector('.aogen-forms-panel');
  if (!panel) return false;
  var fields = block.querySelector('[data-aogen-fields]');
  if (!fields || !fields.children.length) return false;
  return block.getAttribute('data-aogen-ready') === '1';
}

/**
 * Show Connect waitlist as a fixed panel under the wizard shell when a bookable
 * popup venue is selected (datetime / variants). Hide on venue step, waitlist-only,
 * popup flow, and permanent store venues (Carrollton, Dallas, Orlando).
 */
function wbSyncBelowWaitlistPanel(opts) {
  opts = opts || {};
  var wizard = opts.wizard || document.querySelector('.wbw-root');
  if (!wizard) return false;
  var venue;
  if (Object.prototype.hasOwnProperty.call(opts, 'venue')) {
    venue = opts.venue || null;
    wizard.__wbBelowWaitlistVenue = venue;
  } else {
    venue = wizard.__wbBelowWaitlistVenue || null;
  }
  var bookingRoot;
  if (Object.prototype.hasOwnProperty.call(opts, 'bookingRoot')) {
    bookingRoot = opts.bookingRoot || null;
    wizard.__wbBelowWaitlistBookingRoot = bookingRoot;
  } else {
    bookingRoot = wizard.__wbBelowWaitlistBookingRoot || null;
  }

  var shell = wizard.querySelector('[data-wbw-below-waitlist]');
  var belowMount = wizard.querySelector('[data-wbw-aogen-forms-mount="below"]');
  var branch = wizard.getAttribute('data-wbw-branch') || '';
  var popupActive = wizard.classList.contains('wbw-root--aogen-popup-active');
  var block = wbFindWaitlistAogenBlock();
  var want =
    !popupActive &&
    (branch === 'datetime' || branch === 'variants') &&
    !!venue &&
    !wbIsStoreVenue(venue) &&
    wbVenueHasBookableEvents(venue) &&
    !!String(venue.venue_ref_id || venue.venue_id || '').trim();

  if (!want) {
    wizard.setAttribute('data-wbw-below-waitlist', '0');
    wizard.__wbBelowWaitlistCtxKey = '';
    if (shell) {
      shell.hidden = true;
      shell.setAttribute('hidden', '');
      shell.setAttribute('aria-hidden', 'true');
    }
    wbClearBelowWaitlistWatch(wizard);
    return false;
  }

  if (!block) {
    /* Intent only — don't open empty shell; retry lightly until Connect boots. */
    wizard.setAttribute('data-wbw-below-waitlist', '0');
    if (shell) {
      shell.hidden = true;
      shell.setAttribute('hidden', '');
      shell.setAttribute('aria-hidden', 'true');
    }
    wbScheduleBelowWaitlistRetry(wizard);
    return false;
  }

  if (belowMount) wbPlaceAogenFormsBlock(wizard, block);
  if (!popupActive) wbRestoreAogenInlinePanel(block);

  /* Venue only — do not re-dispatch on datetime↔variants (Connect remount race). */
  var ctxKey =
    String(venue.venue_ref_id || venue.venue_id || '') +
    '|' +
    String(venue.venue_name || venue.name || '');
  if (wizard.__wbBelowWaitlistCtxKey !== ctxKey) {
    wizard.__wbBelowWaitlistCtxKey = ctxKey;
    if (
      typeof wbBuildAogenBookingContext === 'function' &&
      typeof wbDispatchAogenBookingContext === 'function'
    ) {
      wbDispatchAogenBookingContext(
        wbBuildAogenBookingContext(venue, bookingRoot, { intent: 'inline' })
      );
    }
  }

  var ready = wbBelowWaitlistFormReady(block);
  wizard.setAttribute('data-wbw-below-waitlist', ready ? '1' : '0');
  if (shell) {
    if (ready) {
      shell.hidden = false;
      shell.removeAttribute('hidden');
      shell.setAttribute('aria-hidden', 'false');
      wbRestoreAogenInlinePanel(block);
      wbPolishBelowWaitlistCard(block, venue);
      wbClearBelowWaitlistWatch(wizard);
    } else {
      shell.hidden = true;
      shell.setAttribute('hidden', '');
      shell.setAttribute('aria-hidden', 'true');
      wbWatchBelowWaitlistReady(wizard, block);
    }
  }
  return ready;
}

function wbClearBelowWaitlistWatch(wizard) {
  if (!wizard) return;
  if (wizard.__wbBelowWaitlistRetryTimer) {
    try {
      clearTimeout(wizard.__wbBelowWaitlistRetryTimer);
    } catch (_) {}
    wizard.__wbBelowWaitlistRetryTimer = 0;
  }
  if (wizard.__wbBelowWaitlistReadyMo) {
    try {
      wizard.__wbBelowWaitlistReadyMo.disconnect();
    } catch (_) {}
    wizard.__wbBelowWaitlistReadyMo = null;
  }
  if (wizard.__wbBelowWaitlistReadyTimer) {
    try {
      clearTimeout(wizard.__wbBelowWaitlistReadyTimer);
    } catch (_) {}
    wizard.__wbBelowWaitlistReadyTimer = 0;
  }
  wizard.__wbBelowWaitlistWatchKey = '';
}

function wbScheduleBelowWaitlistRetry(wizard) {
  if (!wizard || wizard.__wbBelowWaitlistRetryTimer) return;
  var tries = 0;
  function tick() {
    wizard.__wbBelowWaitlistRetryTimer = 0;
    tries += 1;
    if (wbSyncBelowWaitlistPanel({ wizard: wizard }) || tries >= 12) return;
    wizard.__wbBelowWaitlistRetryTimer = setTimeout(tick, 400);
  }
  wizard.__wbBelowWaitlistRetryTimer = setTimeout(tick, 400);
}

function wbWatchBelowWaitlistReady(wizard, block) {
  if (!wizard || !block) return;
  var watchKey = String(wizard.__wbBelowWaitlistCtxKey || '');
  if (wizard.__wbBelowWaitlistReadyMo && wizard.__wbBelowWaitlistWatchKey === watchKey) return;
  wbClearBelowWaitlistWatch(wizard);
  wizard.__wbBelowWaitlistWatchKey = watchKey;

  function tryShow() {
    if (
      wizard.getAttribute('data-wbw-branch') !== 'datetime' &&
      wizard.getAttribute('data-wbw-branch') !== 'variants'
    ) {
      wbClearBelowWaitlistWatch(wizard);
      return true;
    }
    if (wizard.classList.contains('wbw-root--aogen-popup-active')) return false;
    if (!wbBelowWaitlistFormReady(block)) return false;
    wbRestoreAogenInlinePanel(block);
    wizard.setAttribute('data-wbw-below-waitlist', '1');
    var shell = wizard.querySelector('[data-wbw-below-waitlist]');
    if (shell) {
      shell.hidden = false;
      shell.removeAttribute('hidden');
      shell.setAttribute('aria-hidden', 'false');
    }
    wbPolishBelowWaitlistCard(block, wizard.__wbBelowWaitlistVenue || null);
    wbClearBelowWaitlistWatch(wizard);
    return true;
  }

  if (tryShow()) return;

  var mo = new MutationObserver(function () {
    if (wizard.__wbBelowWaitlistReadyTimer) return;
    wizard.__wbBelowWaitlistReadyTimer = setTimeout(function () {
      wizard.__wbBelowWaitlistReadyTimer = 0;
      tryShow();
    }, 100);
  });
  wizard.__wbBelowWaitlistReadyMo = mo;
  mo.observe(block, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['data-aogen-ready', 'data-aogen-mounted', 'hidden'],
  });
  [600, 1500, 3000].forEach(function (ms) {
    setTimeout(function () {
      if (wizard.__wbBelowWaitlistReadyMo) tryShow();
    }, ms);
  });
}

/**
 * Reshape Connect waitlist card under the shell to match PDP waitlist visual:
 * teal eyebrow, bold venue heading, body, inputs, privacy line.
 */
function wbPolishBelowWaitlistCard(block, venue) {
  if (!block || !block.closest || !block.closest('.wbw-aogen-forms-mount--below')) return false;
  var venueName = String(
    (venue && (venue.venue_name || venue.name || venue.city || venue.city_name)) ||
      block.getAttribute('data-venue-name') ||
      block.getAttribute('data-city') ||
      ''
  ).trim();
  if (!venueName) venueName = 'this location';

  var head = block.querySelector('[data-aogen-head]');
  var title = block.querySelector('.aogen-forms-title');
  var intro = block.querySelector('.aogen-forms-intro');
  if (title) {
    title.textContent = "Can't make these dates?";
    title.classList.add('wbw-below-waitlist__eyebrow');
  }
  if (head && intro) {
    var heading = head.querySelector('[data-wbw-wl-heading]');
    if (!heading) {
      heading = document.createElement('p');
      heading.className = 'wbw-below-waitlist__heading';
      heading.setAttribute('data-wbw-wl-heading', '');
      head.insertBefore(heading, intro);
    }
    heading.textContent = "Get notified when we're back in " + venueName;

    var body = String(intro.textContent || '').trim();
    /* Connect sometimes packs heading+body into intro after refresh. */
    var joinIdx = body.search(/Join the waitlist/i);
    if (joinIdx >= 0) body = body.slice(joinIdx);
    else if (/^Get notified when we're back in/i.test(body)) {
      body = body.replace(/^Get notified when we're back in[^.]*\.\s*/i, '');
    } else if (/^Can't make these dates\?/i.test(body)) {
      body = body.replace(/^Can't make these dates\?\s*/i, '');
      if (/^Get notified when we're back in/i.test(body)) {
        body = body.replace(/^Get notified when we're back in[^.]*\.\s*/i, '');
      }
    }
    if (!body || /^Get notified when we're back in/i.test(body)) {
      body =
        'Join the waitlist and be the first to hear when new workshop dates are added.';
    }
    intro.textContent = body;
    intro.classList.add('wbw-below-waitlist__body');
  }

  var disc = block.querySelector('.aogen-forms-disclaimer');
  if (disc) {
    disc.classList.add('wbw-below-waitlist__privacy');
    disc.textContent = '';
    var lock = document.createElement('span');
    lock.className = 'wbw-below-waitlist__lock';
    lock.setAttribute('aria-hidden', 'true');
    lock.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M7 11V8a5 5 0 0 1 10 0v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '<rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.8"/>' +
      '</svg>';
    var privacy = document.createElement('span');
    privacy.textContent = "We'll only email you about new " + venueName + ' workshop dates.';
    disc.appendChild(lock);
    disc.appendChild(privacy);
  }

  var fieldsReady = wbApplyBelowWaitlistFieldHints(block);
  if (fieldsReady) block.setAttribute('data-wbw-wl-polished', '1');
  else block.removeAttribute('data-wbw-wl-polished');
  wbSyncBelowWaitlistCollapse(block);
  wbEnsureBelowWaitlistPolishKeepalive(block);
  return fieldsReady;
}

function wbWaitlistToggleHandler(ev) {
  if (!ev.target || !ev.target.closest) return;
  var title = ev.target.closest('.aogen-forms-title');
  if (!title) return;
  var block = title.closest('[data-wbw-wl-collapsible="1"]');
  if (!block) return;
  if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return;
  ev.preventDefault();
  var open = block.getAttribute('data-wbw-wl-open') === '1';
  block.setAttribute('data-wbw-wl-open', open ? '0' : '1');
  title.setAttribute('aria-expanded', open ? 'false' : 'true');
}

/** This mount only renders alongside bookable sessions, so it always collapses
    to its title row; the toggle is delegated to survive Connect re-renders. */
function wbSyncBelowWaitlistCollapse(block) {
  block.setAttribute('data-wbw-wl-collapsible', '1');
  /* Default open; preserve user toggle after first paint. */
  if (!block.hasAttribute('data-wbw-wl-open')) {
    block.setAttribute('data-wbw-wl-open', '1');
  }
  var title = block.querySelector('.aogen-forms-title');
  if (title) {
    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute(
      'aria-expanded',
      block.getAttribute('data-wbw-wl-open') === '1' ? 'true' : 'false'
    );
  }
  var root = block.closest ? block.closest('.wbw-root') : null;
  if (root && !root.__wbWlToggleBound) {
    root.__wbWlToggleBound = true;
    root.addEventListener('click', wbWaitlistToggleHandler);
    root.addEventListener('keydown', wbWaitlistToggleHandler);
  }
}

function wbBelowWaitlistNeedsPolish(block) {
  if (!block) return true;
  var nameInput = block.querySelector('input[name="name"]');
  var emailInput = block.querySelector('input[name="email"]');
  if (!nameInput || !emailInput) return true;
  if (!String(nameInput.getAttribute('placeholder') || '').trim()) return true;
  if (!String(emailInput.getAttribute('placeholder') || '').trim()) return true;
  if (!block.querySelector('[data-wbw-wl-heading]')) return true;
  if (!block.querySelector('.aogen-forms-disclaimer.wbw-below-waitlist__privacy')) return true;
  return false;
}

/** Set Name/Email placeholders from Connect labels; required before we hide label spans. */
function wbApplyBelowWaitlistFieldHints(block) {
  if (!block) return false;
  var nameInput = block.querySelector('input[name="name"]');
  var emailInput = block.querySelector('input[name="email"]');
  var ok = false;

  function hintFor(input, fallback) {
    if (!input) return;
    var lab = input.closest('label');
    var span = lab && lab.querySelector('span');
    var fromLabel = span ? String(span.textContent || '').trim() : '';
    var ph = fromLabel || fallback;
    if (!ph) return;
    input.setAttribute('placeholder', ph);
    input.setAttribute('aria-label', ph);
    if (lab) {
      lab.classList.add('wbw-below-waitlist__field');
      if (input.getAttribute('name') === 'name') lab.classList.add('wbw-below-waitlist__field--name');
      if (input.getAttribute('name') === 'email') lab.classList.add('wbw-below-waitlist__field--email');
    }
    ok = true;
  }

  hintFor(nameInput, 'Name Surname');
  hintFor(emailInput, 'E-mail');
  return !!(nameInput && emailInput && nameInput.getAttribute('placeholder') && emailInput.getAttribute('placeholder'));
}

/**
 * Connect remount/refresh rebuilds inputs without placeholders. Re-polish while
 * the fixed under-shell card is active — debounced, one observer per block.
 */
function wbEnsureBelowWaitlistPolishKeepalive(block) {
  if (!block || block.__wbBelowPolishMo) return;
  var fields = block.querySelector('[data-aogen-fields]');
  var head = block.querySelector('[data-aogen-head]');
  if (!fields && !head) return;

  var timer = 0;
  var mo = new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () {
      timer = 0;
      var wizard = document.querySelector('.wbw-root');
      if (!wizard || wizard.getAttribute('data-wbw-below-waitlist') !== '1') return;
      if (!block.closest('.wbw-aogen-forms-mount--below')) return;
      if (!wbBelowWaitlistNeedsPolish(block)) return;
      wbPolishBelowWaitlistCard(block, wizard.__wbBelowWaitlistVenue || null);
    }, 80);
  });
  block.__wbBelowPolishMo = mo;
  if (fields) mo.observe(fields, { childList: true, subtree: true });
  if (head) mo.observe(head, { childList: true, subtree: true });
}

function wbStopBelowWaitlistPolishKeepalive(block) {
  if (!block || !block.__wbBelowPolishMo) return;
  try {
    block.__wbBelowPolishMo.disconnect();
  } catch (_) {}
  block.__wbBelowPolishMo = null;
}

/** Undo theme-only head/privacy edits before Connect popup reuses the same block. */
function wbStripBelowWaitlistPolish(block) {
  if (!block) return;
  wbStopBelowWaitlistPolishKeepalive(block);
  block.removeAttribute('data-wbw-wl-polished');
  var heading = block.querySelector('[data-wbw-wl-heading]');
  if (heading) heading.remove();
  var title = block.querySelector('.aogen-forms-title');
  if (title) title.classList.remove('wbw-below-waitlist__eyebrow');
  var intro = block.querySelector('.aogen-forms-intro');
  if (intro) intro.classList.remove('wbw-below-waitlist__body');
  var disc = block.querySelector('.aogen-forms-disclaimer');
  if (disc && disc.classList.contains('wbw-below-waitlist__privacy')) {
    disc.classList.remove('wbw-below-waitlist__privacy');
    disc.textContent = '';
  }
  block.querySelectorAll('.wbw-below-waitlist__field').forEach(function (lab) {
    lab.classList.remove(
      'wbw-below-waitlist__field',
      'wbw-below-waitlist__field--name',
      'wbw-below-waitlist__field--email'
    );
  });
  block.querySelectorAll('input[name="name"], input[name="email"]').forEach(function (input) {
    input.removeAttribute('placeholder');
    input.removeAttribute('aria-label');
  });
}

window.wbSyncBelowWaitlistPanel = wbSyncBelowWaitlistPanel;
window.wbVenueHasBookableEvents = wbVenueHasBookableEvents;
window.wbIsStoreVenue = wbIsStoreVenue;
window.wbPolishBelowWaitlistCard = wbPolishBelowWaitlistCard;
window.wbRestoreAogenInlinePanel = wbRestoreAogenInlinePanel;

function wbMountAogenFormsBlock() {
  var block = wbFindWaitlistAogenBlock();
  var wizard = document.querySelector('.wbw-root');
  if (!block || !wizard) return false;
  wbPlaceAogenFormsBlock(wizard, block);
  wbBindAogenPopupCloseSync(wizard, block);
  var branch = wizard.getAttribute('data-wbw-branch') || '';
  if (
    (branch === 'datetime' || branch === 'variants') &&
    typeof wbSyncBelowWaitlistPanel === 'function'
  ) {
    wbSyncBelowWaitlistPanel({ wizard: wizard });
  }
  if (wizard.__wbAogenFormsMounted) return true;
  wizard.__wbAogenFormsMounted = true;
  var branchMo = new MutationObserver(function () {
    wbPlaceAogenFormsBlock(wizard, block);
  });
  branchMo.observe(wizard, {
    attributes: true,
    attributeFilter: ['data-wbw-branch'],
  });
  var blockMo = new MutationObserver(function () {
    wbSyncConnectWaitlistUi(wizard, block);
  });
  blockMo.observe(block, {
    attributes: true,
    attributeFilter: ['data-aogen-ready', 'data-aogen-mounted', 'data-submit-bound'],
  });
  return true;
}

function wbMountAogenFormsBlockRetry(maxAttempts, delayMs) {
  var attempts = 0;
  function tick() {
    if (wbMountAogenFormsBlock()) return;
    attempts += 1;
    if (attempts >= maxAttempts) return;
    window.setTimeout(tick, delayMs);
  }
  tick();
}

window.wbMountAogenFormsBlock = wbMountAogenFormsBlock;
window.wbAogenConnectFormsAvailable = wbAogenConnectFormsAvailable;
window.wbAogenConnectFormsReady = wbAogenConnectFormsReady;
window.wbAogenFormsBlockReady = wbAogenFormsBlockReady;
window.wbFindWaitlistAogenBlock = wbFindWaitlistAogenBlock;
window.wbCloseNativeWaitlistModal = wbCloseNativeWaitlistModal;

window.__WB_URL_EVENT_ID_NUMERIC__ = window.__WB_URL_EVENT_ID_NUMERIC__ || '';

function wbDiag(label, payload) {
  if (!window.__WB_DIAG__) return;
  console.debug('[WB_DIAG]', label, payload);
}

/**
 * Event status / capacity / sold-out-modal / state-code helpers were moved to
 * workshop-booking-utils.js (window.WorkshopBookingUtils), loaded (defer) before
 * this file. The local bindings below keep every existing call site working
 * without touching the hundreds of references throughout this file.
 */
var __WBU = (typeof window !== 'undefined' && window.WorkshopBookingUtils) || {};
var wbNormalizeEventStatus = __WBU.normalizeEventStatus;
var wbEventCapacityRemaining = __WBU.eventCapacityRemaining;
var wbGetEventStatus = __WBU.getEventStatus;
var wbExtractEventStatusRaw = __WBU.extractEventStatusRaw;
var wbEventLookupKeys = __WBU.eventLookupKeys;
var wbBuildEventStatusLookup = __WBU.buildEventStatusLookup;
var wbLookupEventStatus = __WBU.lookupEventStatus;
var wbIsDisplayStatusBookable = __WBU.isDisplayStatusBookable;
var wbResolveEventStatus = __WBU.resolveEventStatus;
var wbIsEventSoldOut = __WBU.isEventSoldOut;

// Sold-out capacity modal moved to workshop-booking-utils.js.
// window.wbShowSoldOutCapacityModal + window.wbEventBooking are exported there.
var showSoldOutCapacityModal = __WBU.showSoldOutCapacityModal;
var wbIsEventBookable = __WBU.isEventBookable;
var wbShouldHideEvent = __WBU.shouldHideEvent;

/** WB_PERF: only when window.__WB_DIAG__ === true. Log format: [WB_PERF] cycle=<cycleId> req=<reqId> step=<step> ms=<int> extra=<json> */
function wbPerf(cycleId, reqId, step, ms, extra) {
  if (window.__WB_DIAG__ !== true) return;
  var extraStr = (extra != null && typeof extra === 'object') ? JSON.stringify(extra) : (extra != null ? JSON.stringify(String(extra)) : '{}');
  console.log('[WB_PERF] cycle=' + (cycleId != null ? cycleId : '') + ' req=' + (reqId != null ? reqId : '') + ' step=' + step + (ms != null && Number.isFinite(ms) ? ' ms=' + Math.round(ms) : '') + ' extra=' + extraStr);
}

/** In-flight dedupe: window-global so ALL bundles (workshop-booking, events-ui, widget containers) share one map. */
window.__WB_EVENTS_IN_FLIGHT = window.__WB_EVENTS_IN_FLIGHT || Object.create(null);

/**
 * Global fetch interceptor: dedupes ANY events-v GET from third-party bundles
 * (BookThatApp EventsListWidgetContainer / UpcomingEventWidgetContainer).
 * Key strips request_id and normalizes lat/lng to 5 decimals.
 */
if (!window.__WB_FETCH_PATCHED) {
  window.__WB_FETCH_PATCHED = true;
  var _origFetch = window.fetch;
  function _wbNormalizeEventsKey(raw) {
    var k = raw.replace(/([?&])request_id=[^&]*/g, '').replace(/[?&]$/, '');
    k = k.replace(/([?&]lat=)([^&]+)/g, function (m, pre, v) { return pre + (Math.round(parseFloat(v) * 1e5) / 1e5); });
    k = k.replace(/([?&]lng=)([^&]+)/g, function (m, pre, v) { return pre + (Math.round(parseFloat(v) * 1e5) / 1e5); });
    return k;
  }
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
    if (url && url.indexOf('/events-v') !== -1 && (!init || !init.method || init.method === 'GET')) {
      var key = _wbNormalizeEventsKey(url);
      if (window.__WB_EVENTS_IN_FLIGHT[key]) {
        if (window.WB_DEBUG_FETCH) console.log('[WB_FETCH_INTERCEPT]', key, 'deduped');
        return window.__WB_EVENTS_IN_FLIGHT[key].then(function (r) { return r.clone(); });
      }
      var p = _origFetch.apply(this, arguments);
      window.__WB_EVENTS_IN_FLIGHT[key] = p;
      p.then(
        function () { delete window.__WB_EVENTS_IN_FLIGHT[key]; },
        function () { delete window.__WB_EVENTS_IN_FLIGHT[key]; }
      );
      if (window.WB_DEBUG_FETCH) console.log('[WB_FETCH_INTERCEPT]', key, 'new');
      return p;
    }
    return _origFetch.apply(this, arguments);
  };
}

var __WB_lastHandledPlaceFp = '';

async function getLatLngFromPlace(place) {
  if (!place) return null;
  var formattedAddress = (place.formattedAddress || place.formatted_address || '').toString();
  var geo = place.geometry && place.geometry.location;
  if (geo) {
    var lat = typeof geo.lat === 'function' ? geo.lat() : geo.lat;
    var lng = typeof geo.lng === 'function' ? geo.lng() : geo.lng;
    if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)))
      return { lat: Number(lat), lng: Number(lng), formattedAddress: formattedAddress };
  }
  var loc = place.location;
  if (loc) {
    var lat = loc.lat != null ? (typeof loc.lat === 'function' ? loc.lat() : loc.lat) : null;
    var lng = loc.lng != null ? (typeof loc.lng === 'function' ? loc.lng() : loc.lng) : null;
    if (lat == null && loc.latLng && typeof loc.latLng === 'function') {
      var ll = loc.latLng();
      if (ll) { lat = typeof ll.lat === 'function' ? ll.lat() : ll.lat; lng = typeof ll.lng === 'function' ? ll.lng() : ll.lng; }
    }
    if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)))
      return { lat: Number(lat), lng: Number(lng), formattedAddress: formattedAddress };
  }
  if (place.fetchFields && typeof place.fetchFields === 'function' && !place.__wbFieldsFetched) {
    try {
      await place.fetchFields({ fields: ['location'] });
      place.__wbFieldsFetched = true;
      formattedAddress = (place.formattedAddress || place.formatted_address || '').toString();
      geo = place.geometry && place.geometry.location;
      if (geo) {
        lat = typeof geo.lat === 'function' ? geo.lat() : geo.lat;
        lng = typeof geo.lng === 'function' ? geo.lng() : geo.lng;
        if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)))
          return { lat: Number(lat), lng: Number(lng), formattedAddress: formattedAddress };
      }
      loc = place.location;
      if (loc) {
        lat = loc.lat != null ? (typeof loc.lat === 'function' ? loc.lat() : loc.lat) : null;
        lng = loc.lng != null ? (typeof loc.lng === 'function' ? loc.lng() : loc.lng) : null;
        if (lat == null && loc.latLng && typeof loc.latLng === 'function') {
          ll = loc.latLng();
          if (ll) { lat = typeof ll.lat === 'function' ? ll.lat() : ll.lat; lng = typeof ll.lng === 'function' ? ll.lng() : ll.lng; }
        }
        if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng)))
          return { lat: Number(lat), lng: Number(lng), formattedAddress: formattedAddress };
      }
    } catch (_) {}
  }
  return null;
}

/**
 * Extract city, state, state_code, country from Place (B-only: no geometry used for fetch).
 * Supports legacy address_components and new API addressComponents (fetchFields).
 * In workshop-booking handlePlaceSelect, this is only a label fallback when predictionText / formattedAddress
 * comma parsing fails; events are always requested via fetchEventsByLatLng(lat, lng), never via parsed city/state.
 */
async function getCityStateFromPlace(place) {
  if (!place) return null;
  var city = '';
  var state = '';
  var stateCode = '';
  var country = 'US';
  var formattedAddress = (place.formattedAddress || place.formatted_address || '').toString();
  var ac = place.address_components || place.addressComponents;
  if (ac && Array.isArray(ac)) {
    ac.forEach(function (c) {
      var types = c.types || [];
      var longName = c.long_name || c.longText || '';
      var shortName = c.short_name || c.shortText || longName;
      if (types.indexOf('locality') !== -1) city = String(longName).trim();
      else if ((types.indexOf('postal_town') !== -1 || types.indexOf('sublocality') !== -1) && !city) city = String(longName).trim();
      if (types.indexOf('administrative_area_level_1') !== -1) {
        state = String(longName).trim();
        stateCode = String(shortName).trim();
      }
      if (types.indexOf('country') !== -1) country = String(shortName).trim();
    });
  }

  if (!ac || !Array.isArray(ac) || ac.length === 0) {
    if (place.fetchFields && typeof place.fetchFields === 'function' && !place.__wbFieldsFetched) {
      try {
        await place.fetchFields({ fields: ['location'] });
        place.__wbFieldsFetched = true;
        formattedAddress = (place.formattedAddress || place.formatted_address || '').toString();
        ac = place.address_components || place.addressComponents;
        if (ac && Array.isArray(ac)) {
          ac.forEach(function (c) {
            var types = c.types || [];
            var longName = c.long_name || c.longText || '';
            var shortName = c.short_name || c.shortText || longName;
            if (types.indexOf('locality') !== -1) city = String(longName).trim();
            else if ((types.indexOf('postal_town') !== -1 || types.indexOf('sublocality') !== -1) && !city) city = String(longName).trim();
            if (types.indexOf('administrative_area_level_1') !== -1) {
              state = String(longName).trim();
              stateCode = String(shortName).trim();
            }
            if (types.indexOf('country') !== -1) country = String(shortName).trim();
          });
        }
      } catch (_) {}
    }
  }

  if (!stateCode && state) stateCode = state;
  if ((!city || !stateCode) && formattedAddress) {
    var parts = formattedAddress.split(',').map(function (p) { return p.trim(); }).filter(Boolean);
    if (parts.length >= 2 && !city) city = parts[0];
    if (parts.length >= 2 && !state) state = parts[1];
    if (!stateCode && state) stateCode = state.length <= 3 ? state.toUpperCase() : (typeof normalizeStateCode === 'function' ? normalizeStateCode(state) : state.replace(/\s+/g, '-').slice(0, 10));
  }
  if (window.__WB_DIAG__) console.log('[WB_DIAG] getCityStateFromPlace', { city: city, state: state, state_code: stateCode, country: country });
  return { city: city, state: state, state_code: stateCode, country: country, formattedAddress: formattedAddress };
}

// State-code maps + place-label helpers moved to workshop-booking-utils.js.
var STATE_NAME_TO_CODE = __WBU.STATE_NAME_TO_CODE;
var normalizeStateCode = __WBU.normalizeStateCode;
var WB_CATALOG_REGION_NAME_TO_CODE = __WBU.CATALOG_REGION_NAME_TO_CODE;
var parseCityStateFromFormattedAddress = __WBU.parseCityStateFromFormattedAddress;
var getPlaceDisplayLabel = __WBU.getPlaceDisplayLabel;

var _lastPlaceSelectMs = 0;
function onPlaceSelect(ev) {
  var now = Date.now();
  if (now - _lastPlaceSelectMs < 500) return;
  _lastPlaceSelectMs = now;
  if (typeof window.__WB_onPlaceSelect === 'function') window.__WB_onPlaceSelect(ev);
}

function ensureDocPlaceListeners() {
  if (window.__WB_DOC_PLACE_LISTENERS__) return;
  window.__WB_DOC_PLACE_LISTENERS__ = true;

  document.addEventListener('gmp-placeselect', onPlaceSelect, true);
  document.addEventListener('gmp-select', onPlaceSelect, true);
  document.addEventListener('place_changed', onPlaceSelect, true);

  if (window.__WB_DIAG__) console.log('[WB_DIAG] doc place listeners bound');
}

function applyWizardPlaceAutocompleteChrome(placeEl) {
  if (!placeEl) return false;
  var booking = placeEl.closest && placeEl.closest('.pdp-workshop-booking.wb-wizard');
  if (!booking) return false;
  try {
    placeEl.setAttribute('no-input-icon', '');
    placeEl.noInputIcon = true;
  } catch (_) {}
  try {
    placeEl.style.setProperty('color-scheme', 'light');
    placeEl.style.setProperty('border', 'none');
    placeEl.style.setProperty('border-radius', '0');
    placeEl.style.setProperty('box-shadow', 'none');
    placeEl.style.setProperty('outline', 'none');
    placeEl.style.setProperty('background-color', 'transparent');
    placeEl.style.setProperty('background', 'transparent');
  } catch (_) {}
  return true;
}

function applyPlaceAutocompleteLightTheme(placeEl) {
  try {
    if (
      !placeEl ||
      !placeEl.matches ||
      !placeEl.matches('gmp-place-autocomplete')
    )
      return;
    var booking = placeEl.closest && placeEl.closest('.pdp-workshop-booking');
    var isWizard = !!(booking && booking.classList && booking.classList.contains('wb-wizard'));
    placeEl.style.setProperty('color-scheme', 'light');
    placeEl.style.setProperty('--gmp-mat-color-surface', isWizard ? 'transparent' : '#ffffff');
    placeEl.style.setProperty('--gmp-mat-color-on-surface', '#111827');
    placeEl.style.setProperty('--gmp-mat-color-on-surface-variant', '#6b7280');
    if (isWizard) {
      placeEl.style.setProperty('border', 'none');
      placeEl.style.setProperty('outline', 'none');
      placeEl.style.setProperty('box-shadow', 'none');
      placeEl.style.setProperty('background', 'transparent');
      applyWizardPlaceAutocompleteChrome(placeEl);
    }
  } catch (_) {}
}

function ensurePlaceListeners(placeEl) {
  if (!placeEl) return;
  applyPlaceAutocompleteLightTheme(placeEl);
  applyWizardPlaceAutocompleteChrome(placeEl);
  if (placeEl.dataset) placeEl.dataset.wbBoundV = String(window.__WB_BIND_VERSION__ || 0);

  placeEl.removeEventListener('gmp-placeselect', onPlaceSelect, true);
  placeEl.addEventListener('gmp-placeselect', onPlaceSelect, true);
  placeEl.removeEventListener('gmp-select', onPlaceSelect, true);
  placeEl.addEventListener('gmp-select', onPlaceSelect, true);
  placeEl.removeEventListener('place_changed', onPlaceSelect, true);
  placeEl.addEventListener('place_changed', onPlaceSelect, true);

  // Fallback: if place events don't fire, a debounced 'change' listener tries getPlace()
  if (!placeEl.__wbChangeFallbackBound) {
    placeEl.__wbChangeFallbackBound = true;
    var changeTimer = null;
    placeEl.addEventListener('change', function () {
      if (changeTimer) clearTimeout(changeTimer);
      changeTimer = setTimeout(function () {
        changeTimer = null;
        if (typeof placeEl.getPlace !== 'function') return;
        try {
          var p = placeEl.getPlace();
          if (p && typeof p.then === 'function') {
            p.then(function (resolved) { if (resolved) onPlaceSelect({ target: placeEl, detail: resolved }); }).catch(function () {});
          } else if (p) {
            onPlaceSelect({ target: placeEl, detail: p });
          }
        } catch (_) {}
      }, 300);
    });
  }

  if (window.__WB_DIAG__) console.log('[WB_DIAG] ensurePlaceListeners bound (capture)', { tag: placeEl.tagName, id: placeEl.id });
}

function initWorkshopBooking() {
  var wbSheetBodyEl = document.getElementById('wb-sheet-body');
  var bookingCandidates = document.querySelectorAll('.pdp-workshop-booking');
  var wizardBooking = null;
  for (var wbPick = 0; wbPick < bookingCandidates.length; wbPick++) {
    if (bookingCandidates[wbPick].classList.contains('wb-wizard')) {
      wizardBooking = bookingCandidates[wbPick];
      break;
    }
  }
  const booking =
    (wbSheetBodyEl && wbSheetBodyEl.querySelector('.pdp-workshop-booking')) ||
    wizardBooking ||
    bookingCandidates[0] ||
    document.querySelector('.pdp-workshop-booking') ||
    document.querySelector('.workshop-booking');
  if (!booking) return;

  // Idempotency: if this exact DOM node was already fully initialised, skip.
  // When Shopify replaces section HTML (section:load), the new element has no __wbBound → re-inits.
  // When Shopify fires section:select on the same DOM node → skips (prevents duplicate listeners).
  if (booking.__wbBound === true) {
    if (typeof window !== 'undefined' && (window.__WB_DEV__ === true || window.__WB_DEBUG__ === true)) {
      console.log('[WB_INIT] skipping — this booking DOM node already bound');
    }
    return;
  }
  booking.__wbBound = true;
  try {
    var isInSheetCtx = !!(booking.closest && booking.closest('#wb-sheet-body'));
    booking.classList.toggle('wb-in-sheet', isInSheetCtx);
    booking.classList.toggle('wb-standalone', !isInSheetCtx);
  } catch (_) {}

  window.__WB_BIND_VERSION__ = (window.__WB_BIND_VERSION__ || 0) + 1;
  if (window.__WB_DIAG__) console.log('[WB_DIAG] initWorkshopBooking', { v: window.__WB_BIND_VERSION__ });

  var proxyFromRoot = (booking.getAttribute && booking.getAttribute('data-wb-proxy-base'))
    || (booking.getAttribute && booking.getAttribute('data-events-proxy-url'))
    || (booking.dataset && booking.dataset.wbProxyBase)
    || (booking.dataset && booking.dataset.eventsProxyUrl) || '';
  if (proxyFromRoot) proxyFromRoot = String(proxyFromRoot).replace(/\/+$/, '');
  var PROXY_BASE = proxyFromRoot || '/apps/workshop-events';
  var PROXY_BASE_FALLBACK = proxyFromRoot || '/apps/workshop-event';
  var eventsPathAttr = (booking.getAttribute && booking.getAttribute('data-wb-events-path'))
    || (booking.dataset && booking.dataset.wbEventsPath) || '';
  var EVENTS_PATH = (eventsPathAttr && String(eventsPathAttr).trim()) ? String(eventsPathAttr).trim() : '/events-v';
  var venueListSortAttr =
    (booking.getAttribute && booking.getAttribute('data-wb-venue-list-sort')) ||
    (booking.dataset && booking.dataset.wbVenueListSort) ||
    '';
  var VENUE_LIST_SORT_MODE = String(venueListSortAttr || 'distance').trim().toLowerCase().replace(/-/g, '_');
  if (VENUE_LIST_SORT_MODE !== 'events_first') VENUE_LIST_SORT_MODE = 'distance';
  var DEV_MODE = typeof window !== 'undefined' && (window.__WB_DEV__ === true || window.__WB_DEBUG__ === true);
  // joinProxyPath + fetchWorkshopEvents moved to workshop-booking-events.js
  // (window.WorkshopBookingEvents). Bind them to THIS root's proxy config; the
  // 15s hung-proxy TimeoutError guard and 404 legacy retry live in the module.
  var __wbEvents =
    (typeof window !== 'undefined' &&
      window.WorkshopBookingEvents &&
      window.WorkshopBookingEvents.create({
        proxyBase: PROXY_BASE,
        proxyBaseFallback: PROXY_BASE_FALLBACK,
        eventsPath: EVENTS_PATH,
        timeoutMs: 15000,
        devMode: DEV_MODE
      })) ||
    null;
  var joinProxyPath =
    (window.WorkshopBookingEvents && window.WorkshopBookingEvents.joinProxyPath) ||
    function (base, path) {
      var b = String(base).replace(/\/+$/, '');
      var p = String(path);
      if (p.charAt(0) !== '/') p = '/' + p;
      return b + p;
    };
  function fetchWorkshopEvents(queryString, fetchOpts) {
    if (__wbEvents) return __wbEvents.fetchWorkshopEvents(queryString, fetchOpts);
    return fetch(joinProxyPath(PROXY_BASE, EVENTS_PATH) + '?' + queryString, fetchOpts);
  }
  /** Log backend rid when present in parsed data (call from response handler). */
  function logBackendRidIfPresent(requestId, data) {
    if (!DEV_MODE || requestId == null) return;
    if (data && data.meta && data.meta.debug && data.meta.debug.rid)
      console.log('[WB_EVENTS] request_id=' + requestId + ' backend_rid=' + data.meta.debug.rid);
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(() => {
      const lp = document.querySelector('[data-last-price]');
      const vs = document.getElementById('workshop-variant');
      if (lp && vs && typeof setLastPriceFromVariant === 'function') setLastPriceFromVariant();
      if (typeof updateAllVariantCardPrices === 'function') updateAllVariantCardPrices();
    });
  });

  const stateInput = document.getElementById('workshop-state-input');
  const cityInput = document.getElementById('workshop-city-input');
  /** Scope to this booking — duplicate #workshop-variant ids would otherwise bind the wrong hidden input (sheet vs PDP). */
  const variantSelect =
    booking.querySelector('#workshop-variant') ||
    booking.querySelector('[data-workshop-variant-hidden]') ||
    document.getElementById('workshop-variant');
  var __wbLive = {
    variantFilterActive: false,
    lockedVenueRefId: '',
    lockedVenueGroupKey: ''
  };

  const eventsRoot = booking.querySelector('[data-workshop-events]');
  const eventsPlaceholder = booking.querySelector('[data-workshop-events-placeholder]');
  function wbwDispatchVenueReset() {
    if (!booking.classList || !booking.classList.contains('wb-wizard')) return;
    try {
      document.dispatchEvent(
        new CustomEvent('wbw:venue-reset', { detail: { bookingRoot: booking } })
      );
    } catch (_) {}
  }
  /** Show user-friendly error in events area (do not assume fetch returned valid JSON). */
  function showWorkshopFetchError(msg) {
    wbwDispatchVenueReset();
    if (eventsRoot) eventsRoot.innerHTML = '';
    if (eventsPlaceholder) {
      eventsPlaceholder.classList.remove('pdp-wb-hidden');
      eventsPlaceholder.textContent = (msg && String(msg).trim()) ? String(msg).trim() : "Couldn't load sessions. Try again.";
    }
    if (booking.classList && booking.classList.contains('wb-wizard')) {
      try {
        wbRefreshBookingGuideUi();
      } catch (_) {}
    }
  }

  /** Single loader: placeholder only. No extra node in [data-workshop-events]. Always queries from booking. */
  function setLoading(bookingRoot, show) {
    var root = bookingRoot && bookingRoot.querySelector('[data-workshop-events]');
    var ph = bookingRoot && bookingRoot.querySelector('[data-workshop-events-placeholder]');
    if (show) {
      if (bookingRoot === booking) wbwDispatchVenueReset();
      var hasCards =
        root &&
        root.querySelector(
          '.wb-venue-card, .wbw-venue-pick-card, .workshop-venue-card, .wb-venue-pick-card--sessions'
        );
      /* Keep existing cards while a refresh is in flight — clearing caused blank hung shells. */
      if (root && !hasCards) root.innerHTML = '';
      if (ph) {
        if (hasCards) {
          ph.classList.add('pdp-wb-hidden');
        } else {
          ph.textContent = 'Loading sessions\u2026';
          ph.classList.remove('pdp-wb-hidden');
        }
      }
    } else {
      var loaders = bookingRoot ? bookingRoot.querySelectorAll('[data-workshop-loading="1"]') : [];
      loaders.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      if (ph) ph.classList.add('pdp-wb-hidden');
    }
  }

  const variantWrap = booking.querySelector('[data-workshop-variant-wrap]');
  const eventsPayloadScript = booking.querySelector('script[data-workshop-events-payload]');
  const productHandle = (booking.dataset.productHandle || '').trim().toLowerCase();
  const productGid = (booking.dataset.productGid || '').trim();

  const useLocationFirst = Boolean(eventsRoot && eventsPayloadScript && productHandle);

  // Google key can be on a child node OR on the booking root itself.
  const googleKeyEl =
    (booking && booking.querySelector && booking.querySelector('[data-google-maps-key]')) ||
    (booking && booking.hasAttribute && booking.hasAttribute('data-google-maps-key') ? booking : null);

  const googleKey = (
    googleKeyEl
      ? (googleKeyEl.getAttribute('data-key') || (googleKeyEl.dataset && googleKeyEl.dataset.key) || '')
      : ''
  ) || (typeof window !== 'undefined' && window.__WB_GMAPS_KEY ? String(window.__WB_GMAPS_KEY) : '');
  if (useLocationFirst && !googleKey && window.__WB_DIAG__) {
    console.warn('[Workshop] Google Maps key missing. Add api_key to google_maps metaobject (or api_keys.google_maps), or set workshop_google_maps_api_key in theme settings.');
  }

  const bookingBox = booking.querySelector('[data-workshop-booking]');
  if (bookingBox) bookingBox.classList.add('wb-no-event-selected');
  const bookingHint = bookingBox ? bookingBox.querySelector('[data-booking-hint]') : null;
  var panelScopeRoot = booking.querySelector('[data-wb-panel-scope]') || booking;
  const panelTitle = panelScopeRoot.querySelector('[data-wb-panel-title]');
  const panelHintEl = panelScopeRoot.querySelector('[data-wb-panel-hint]');
  const selectedSummary = bookingBox ? bookingBox.querySelector('[data-selected-event-summary]') : null;
  const selectedEventIdInput = bookingBox ? bookingBox.querySelector('[data-selected-event-id]') : null;
  const lastPriceEl = bookingBox ? bookingBox.querySelector('[data-last-price]') : null;
  const selectedItemsWrap = bookingBox ? bookingBox.querySelector('[data-wb-selected-items]') : null;
  const selectedItemsList = bookingBox ? bookingBox.querySelector('[data-wb-selected-items-list]') : null;
  const selectedItemsTotal = bookingBox ? bookingBox.querySelector('[data-wb-selected-items-total]') : null;
  const bookNowBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;
  const addToCartBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;

  const summaryVenue = bookingBox ? bookingBox.querySelector('[data-selected-event-venue]') : null;
  const summaryVenueDetails = bookingBox ? bookingBox.querySelector('[data-selected-event-venue-details]') : null;
  const summaryDatetime = bookingBox ? bookingBox.querySelector('[data-selected-event-datetime]') : null;
  const summaryCapacity = bookingBox ? bookingBox.querySelector('[data-selected-event-capacity]') : null;
  const summaryStatus = bookingBox ? bookingBox.querySelector('[data-selected-event-status]') : null;

  const normalize = (v) => (v || '').toString().trim();
  const normKey = (v) => normalize(v).toLowerCase();

  function formatMoney(cents) {
    const c = typeof cents === 'number' ? cents : parseInt(cents || '0', 10);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(c, window.Shopify.money_format);
      } catch (_) {}
    }
    // Fallback
    return `$${(c / 100).toFixed(2)}`;
  }

  /** Bottom price: list (base) above sale when resolved < base. Expects workshop-final-price inner spans. */
  function setLastPriceElDisplay(el, baseCents, resolvedCents) {
    if (!el) return;
    var compareEl = el.querySelector('[data-last-price-compare]');
    var currentEl = el.querySelector('[data-last-price-current]');
    var dashHtml = '<span style="color:#999;">—</span>';
    var resolved =
      typeof resolvedCents === 'number' && Number.isFinite(resolvedCents) && resolvedCents > 0 ? resolvedCents : null;
    var base =
      typeof baseCents === 'number' && Number.isFinite(baseCents) && baseCents > 0 ? baseCents : null;

    if (!currentEl) {
      if (!resolved) el.innerHTML = dashHtml;
      else el.textContent = formatMoney(resolved);
      return;
    }

    if (!resolved) {
      currentEl.innerHTML = dashHtml;
      if (compareEl) {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
      return;
    }

    currentEl.textContent = formatMoney(resolved);
    if (compareEl && base != null && base > resolved) {
      compareEl.textContent = formatMoney(base);
      compareEl.hidden = false;
    } else if (compareEl) {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }
  }

  function readJsonScriptInBooking(selector) {
    const el = booking.querySelector(selector);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (_) {
      return [];
    }
  }

  /** Optional: set true to log event-time override parsing and matching. Default false. */
  const WB_PRICE_DEBUG = false;

  const locationRules = readJsonScriptInBooking('script[data-workshop-location-rules]');
  const venueOverrides = readJsonScriptInBooking('script[data-workshop-venue-overrides]');
  const eventTimeOverrides = readJsonScriptInBooking('script[data-workshop-event-time-overrides]');
  if (WB_PRICE_DEBUG && typeof window !== 'undefined' && !window.__wbETOLogged) {
    window.__wbETOLogged = true;
    try {
      console.log('[WB] eventTimes parsed', { count: eventTimeOverrides.length, first: eventTimeOverrides[0] });
    } catch (_) {}
  }

  function wbDiag(label, data) {
    if (typeof window !== 'undefined' && window.__WB_DIAG__) {
      try { console.log('[WB] ' + label, data != null ? data : ''); } catch (_) {}
    }
  }

  function getSelections() {
    return {
      state: useLocationFirst ? (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.state) || '' : normalize(stateInput && stateInput.value),
      city: useLocationFirst ? (window.__WORKSHOP_LOCATION__ && window.__WORKSHOP_LOCATION__.city) || '' : normalize(cityInput && cityInput.value),
      variant: normalize(variantSelect && variantSelect.value),
    };
  }

  function getSelectedVariantPriceCents() {
    if (!variantSelect) return null;
    var activeBtn = booking.querySelector('.wb-variant-btn.is-active');
    if (activeBtn) {
      var cents = activeBtn.dataset.basePrice;
      return cents ? parseInt(cents, 10) : null;
    }
    var val = variantSelect.value;
    if (!val) return null;
    var fallback = booking.querySelector('.wb-variant-btn[data-variant-id="' + CSS.escape(val) + '"]');
    return fallback && fallback.dataset.basePrice ? parseInt(fallback.dataset.basePrice, 10) : null;
  }

  function getSelectedVariantId() {
    if (!variantSelect) return '';
    return variantSelect.value || '';
  }

  // Helper — call this wherever the booking step changes
  function wstUpdate(step, values) {
    document.dispatchEvent(new CustomEvent('wst:update', {
      detail: { step: step, values: values || {} }
    }));
  }

  function wstFormatDateKey(dateKey) {
    var raw = String(dateKey || '').trim();
    if (!raw) return '';
    var d = new Date(raw + 'T00:00:00');
    if (Number.isNaN(d.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
    } catch (_) {
      return raw;
    }
  }

  function wstValues(venueName, dateLabel, timeLabel, kitName, extrasName) {
    var values = {};
    var v1 = String(venueName || '').trim();
    var v2 = String(dateLabel || '').trim();
    var v3 = String(timeLabel || '').trim();
    var v4 = String(kitName || '').trim();
    var v6 = String(extrasName || '').trim();
    if (v1) values[1] = v1;
    if (v2) values[2] = v2;
    if (v3) values[3] = v3;
    if (v4) values[4] = v4;
    if (v6) values[6] = v6;
    return values;
  }
  /** Last two args: ticket quantity (step 5), extras label (step 6). */
  function wstValuesWithQty(venueName, dateLabel, timeLabel, kitName, ticketQtyLabel, extrasLabel) {
    var values = wstValues(venueName, dateLabel, timeLabel, kitName, extrasLabel);
    var v5 = String(ticketQtyLabel || '').trim();
    if (v5) values[5] = v5;
    return values;
  }
  function wstGetVariantNameFromButton(btn) {
    if (!btn) return '';
    var name = String(btn.getAttribute('data-variant-title') || btn.dataset.variantTitle || '').trim();
    if (!name) {
      var titleEl = btn.querySelector('.wb-variant-title');
      name = titleEl ? String(titleEl.textContent || '').trim() : '';
    }
    return name;
  }

  function wstGetActiveVariantName() {
    var activeBtn = booking ? booking.querySelector('.wb-variant-btn.is-active') : null;
    return wstGetVariantNameFromButton(activeBtn);
  }

  function wstGetCurrentBookingFacts() {
    var selectedCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
    if (!selectedCard) return null;
    var qtyInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
    var qtyNum = Number((qtyInput && qtyInput.value) || 1);
    if (!Number.isFinite(qtyNum) || qtyNum < 1) qtyNum = 1;
    return {
      venueName: String(selectedCard.getAttribute('data-venue-name') || '').trim(),
      dateLabel: wstFormatDateKey(selectedCard.getAttribute('data-date-key') || ''),
      timeLabel: String(selectedCard.getAttribute('data-time-label') || '').trim(),
      variantName: wstGetActiveVariantName(),
      extrasName: (function () {
        var addon = typeof addonSelection === 'function' ? addonSelection() : null;
        return addon && addon.selected ? String(addon.title || '').trim() : 'None';
      })(),
      qtyLabel: String(Math.round(qtyNum))
    };
  }

  // isBlank + matchDim moved into workshop-booking-pricing.js (pricing-only helpers).

  /** Canonical event id for matching: Liquid outputs metaobject system.id (numeric); card may have ev.id (numeric) or ev.event_metaobject_gid (GID). */
  function normalizeEventIdForMatch(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (s === '') return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return s;
  }

  /** Numeric id for URL param (metaobject GID or plain digits); empty string if not extractable. */
  function extractNumericEventIdForUrl(val) {
    if (val == null) return '';
    var s = String(val).trim();
    if (!s) return '';
    var metaGid = /^gid:\/\/shopify\/Metaobject\/(\d+)$/i.exec(s);
    if (metaGid) return metaGid[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  function getEventIdFromUrl() {
    // Prefer value captured at script-load time (before theme strips it from URL)
    if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') {
      return String(window.__WB_INITIAL_EVENT_ID__).trim();
    }
    try {
      var params = new URLSearchParams(window.location.search);
      return (params.get('event_id') || '').trim();
    } catch (e) { return ''; }
  }

  function updateUrlForEventId(eventId) {
    try {
      var params = new URLSearchParams(window.location.search);
      var numericEventId = extractNumericEventIdForUrl(eventId);
      if (numericEventId) {
        window.__WB_STRIP_EVENT_ID_PARAM__ = false;
        params.set('event_id', numericEventId);
      } else {
        window.__WB_STRIP_EVENT_ID_PARAM__ = true;
        window.__WB_URL_EVENT_ID_NUMERIC__ = '';
        window.__WB_INITIAL_EVENT_ID__ = null;
        params.delete('event_id');
      }
      var qs = params.toString();
      var nextUrl = window.location.pathname + (qs ? ('?' + qs) : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
      window.__WB_URL_EVENT_ID_NUMERIC__ = numericEventId || '';
    } catch (e) {}
  }

  if (!window.__WB_HISTORY_EVENT_PATCHED__) {
    window.__WB_HISTORY_EVENT_PATCHED__ = true;
    (function patchHistoryState() {
      function wbStickyBookingParams(absoluteUrl, currentParams) {
        /* Intentional clears (Back / Places search) set strip flags so theme sticky
         * cannot re-inject venue/event_id from the still-current URL during replaceState. */
        var stripEventId = !!window.__WB_STRIP_EVENT_ID_PARAM__;
        var stickyEventId = stripEventId
          ? ''
          : (currentParams.get('event_id') || '').trim() || (window.__WB_URL_EVENT_ID_NUMERIC__ || '');
        if (stickyEventId && !(absoluteUrl.searchParams.get('event_id') || '').trim()) {
          absoluteUrl.searchParams.set('event_id', stickyEventId);
        }
        var stickyVariant =
          (currentParams.get('variant') || '').trim() || (window.__WB_URL_VARIANT_NUMERIC__ || '');
        if (
          stickyVariant &&
          window.__WB_LOCK_VARIANT_URL__ === true &&
          !(absoluteUrl.searchParams.get('variant') || '').trim()
        ) {
          absoluteUrl.searchParams.set('variant', stickyVariant);
        }
        var stripVenue = !!window.__WB_STRIP_VENUE_PARAM__;
        var stickyVenue = stripVenue ? '' : (currentParams.get('venue') || '').trim();
        if (stickyVenue && !(absoluteUrl.searchParams.get('venue') || '').trim()) {
          absoluteUrl.searchParams.set('venue', stickyVenue);
        }
        return absoluteUrl.pathname + absoluteUrl.search + absoluteUrl.hash;
      }

      var originalReplaceState = history.replaceState;
      history.replaceState = function (state, unused, url) {
        try {
          var hasUrlArg = url != null && String(url) !== '';
          if (hasUrlArg) {
            var currentParams = new URLSearchParams(window.location.search);
            var absoluteUrl = new URL(String(url), window.location.origin);
            url = wbStickyBookingParams(absoluteUrl, currentParams);
          }
        } catch (e) {}
        return originalReplaceState.call(this, state, unused, url);
      };

      var originalPushState = history.pushState;
      history.pushState = function (state, unused, url) {
        try {
          var hasUrlArg = url != null && String(url) !== '';
          if (hasUrlArg) {
            var currentParams = new URLSearchParams(window.location.search);
            var absoluteUrl = new URL(String(url), window.location.origin);
            url = wbStickyBookingParams(absoluteUrl, currentParams);
          }
        } catch (e) {}
        return originalPushState.call(this, state, unused, url);
      };
    })();
  }

  // matchEventId / matchVariant / matchVariantExact / toCentsInt / matchLocationScope /
  // specificityCount / pickBest moved into workshop-booking-pricing.js (pricing-only).

  // Price resolution engine moved to workshop-booking-pricing.js
  // (window.WorkshopBookingPricing). Bind a resolver to THIS booking root's parsed
  // rule sets and keep the resolvePriceCents(params, testOverrides) signature +
  // the global window.resolveWorkshopPrice export (workshop-cart.js depends on it).
  var __wbPricing =
    (typeof window !== 'undefined' &&
      window.WorkshopBookingPricing &&
      window.WorkshopBookingPricing.create({
        locationRules: locationRules,
        venueOverrides: venueOverrides,
        eventTimeOverrides: eventTimeOverrides,
        productId: (booking && booking.dataset && booking.dataset.productId) || '',
        debug: WB_PRICE_DEBUG
      })) ||
    null;
  function resolvePriceCents(params, testOverrides) {
    if (__wbPricing) return __wbPricing.resolve(params, testOverrides);
    return params && typeof params.basePriceCents === 'number' ? params.basePriceCents : 0;
  }

    // Expose resolver globally once (for workshop-cart.js)
    if (typeof window !== 'undefined') window.resolveWorkshopPrice = resolvePriceCents;

  function diagnosticRun() {
    if (typeof window === 'undefined' || !window.__WB_DIAG__) return;
    const base = 1000;
    const opts = { basePriceCents: base, eventId: '', state: '', city: '', venueName: '', variantId: '1', workshopId: '' };
    const venue = (name, city, state, variantId, priceCents) => ({ venue_name: name || '', city: city || '', state: state || '', scope: variantId != null ? 'single_variant' : null, variant_id: variantId != null ? variantId : null, price_cents: priceCents });
    let r;
    r = resolvePriceCents({ ...opts, venueName: 'Some Venue', city: 'LA' }, { locationRules: [], venueOverrides: [venue('', 'NYC', '', null, -5)], eventTimeOverrides: [] });
    console.assert(r === base, 'Venue override with blank venue_name must not match (no global bleed)');
    r = resolvePriceCents({ ...opts, venueName: 'Some Venue', city: 'LA' }, { locationRules: [], venueOverrides: [venue('Some Venue', 'NYC', '', null, 500)], eventTimeOverrides: [] });
    console.assert(r === base, 'Venue override with city=NYC must not match when selection city is LA');
    r = resolvePriceCents({ ...opts, venueName: 'V', variantId: '222' }, { locationRules: [], venueOverrides: [venue('V', '', '', '111', 500)], eventTimeOverrides: [] });
    console.assert(r === base, 'Variant-scoped venue override must not apply to other variant');
    r = resolvePriceCents({ ...opts, venueName: 'V' }, { locationRules: [], venueOverrides: [venue('V', '', '', null, -100)], eventTimeOverrides: [] });
    console.assert(r === 900, 'Negative venue override must apply as delta (1000 + -100 = 900)');
    wbDiag('diagnosticRun', 'all asserts passed');
  }
  if (typeof window !== 'undefined' && window.__WB_DIAG__) {
    try { diagnosticRun(); } catch (e) { console.warn('[WB] diagnosticRun failed', e); }
  }

  function updateSelectedEventPrices(selectedCard) {
    const base = getSelectedVariantPriceCents();
    if (!base || Number.isNaN(base)) return;

    const variantId = variantSelect ? variantSelect.value : '';
    const eventId = (selectedCard.dataset.eventMetaobjectGid || selectedCard.dataset.eventId || '').toString().trim();
    const state = selectedCard.dataset.state || '';
    const city = selectedCard.dataset.city || '';
    const cityKey = (selectedCard.dataset.cityKey || '').toString().trim();
    const venueName = (selectedCard.dataset.venueName || '').toString().trim();
    const venueHandle = (selectedCard.dataset.venueHandle || '').toString().trim();

    const resolved = resolvePriceCents({
      basePriceCents: base,
      eventId,
      state,
      city,
      cityKey,
      venueName,
      venueHandle,
      variantId,
    });

    if (lastPriceEl) setLastPriceElDisplay(lastPriceEl, base, resolved);

    const priceEl = selectedCard.querySelector('[data-event-final-price]');
    if (priceEl) priceEl.textContent = formatMoney(resolved);

    // Store resolved cents on the card so we can send it on add-to-cart.
    selectedCard.dataset.resolvedPriceCents = String(resolved);
  }

  /** AUDIT: Writes base price to [data-last-price] when no event selected. Reads .wb-variant-btn.is-active dataset.basePrice. */
  function setLastPriceFromVariant() {
    let lp = lastPriceEl;
    if (!document.body.contains(lp) && booking) lp = booking.querySelector('[data-last-price]');
    if (!lp) return;
    var activeBtn = booking.querySelector('.wb-variant-btn.is-active');
    var cents = activeBtn && activeBtn.dataset.basePrice ? parseInt(activeBtn.dataset.basePrice, 10) : null;
    if (!cents || Number.isNaN(cents)) {
      setLastPriceElDisplay(lp, null, null);
      return;
    }
    setLastPriceElDisplay(lp, cents, cents);
  }

  /**
   * Update the single [data-variant-price] element per variant card.
   * AUDIT: Bottom-left price is set by showPreviewPrice(card) and setLastPriceFromVariant().
   * resolvePriceCents inputs: basePriceCents, eventId, state, city, venueName, variantId, workshopId.
   * Rule sources: locationRules, venueOverrides, eventTimeOverrides (from script[data-workshop-*] in booking).
   * Resolver returns cents (integer); no match => returns base. Invalid base => can return NaN (we fallback).
   * - If NO event selected → show BASE only (do not call resolver).
   * - If event selected → show RESOLVED per variant; if resolved invalid/<=0 → fallback to base.
   */
  function updateAllVariantCardPrices() {
    var root = booking && document.body && document.body.contains(booking)
      ? booking
      : (document.querySelector('.pdp-workshop-booking') || document.querySelector('.workshop-booking'));
    if (!root) return;

    var eventsContainer = root.querySelector('[data-workshop-events]');
    var selectedCard = eventsContainer ? eventsContainer.querySelector('.workshop-event-card.is-selected') : null;
    if (!selectedCard) {
      var sheetRoot0 = document.getElementById('wb-sheet-body');
      var hasSheetBookingUi0 = sheetRoot0 && sheetRoot0.querySelector('.pdp-workshop-booking');
      var inSheetContext0 = !!(root && root.closest && root.closest('#wb-sheet-body'));
      if (hasSheetBookingUi0 && inSheetContext0) {
        selectedCard =
          document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
          document.querySelector('.wb-all__event-card.is-selected');
      }
    }

    var variantBtns = root.querySelectorAll('.wb-variant-btn');
    var workshopId = (root.dataset && root.dataset.productId) ? String(root.dataset.productId) : '';

    if (!selectedCard) {
      for (var i = 0; i < variantBtns.length; i++) {
        var btn0 = variantBtns[i];
        var base0 = btn0.dataset.basePrice ? parseInt(btn0.dataset.basePrice, 10) : 0;
        if (base0 != null && !Number.isNaN(base0) && base0 < 0) base0 = 0;
        var priceEl0 = btn0.querySelector('[data-variant-price]');
        if (priceEl0) priceEl0.textContent = formatMoney(base0);
        var compareEl0 = btn0.querySelector('[data-variant-compare-price]');
        var row0 = btn0.querySelector('[data-variant-price-row]');
        if (compareEl0) {
          compareEl0.textContent = '';
          compareEl0.style.display = 'none';
        }
        if (row0) row0.classList.remove('wb-variant-prices--on-sale');
      }
      return;
    }

    var eventId = (selectedCard.dataset.eventMetaobjectGid || selectedCard.dataset.eventId || '').toString().trim();
    var state = selectedCard.dataset.state || '';
    var city = selectedCard.dataset.city || '';
    var cityKey = (selectedCard.dataset.cityKey || '').toString().trim();
    var venueName = (selectedCard.dataset.venueName || '').toString().trim();
    var venueHandle = (selectedCard.dataset.venueHandle || '').toString().trim();

    for (var j = 0; j < variantBtns.length; j++) {
      var btn = variantBtns[j];
      var baseCents = btn.dataset.basePrice ? parseInt(btn.dataset.basePrice, 10) : null;
      if (baseCents == null || Number.isNaN(baseCents)) baseCents = 0;
      var variantId = (btn.dataset.variantId || '').toString().trim();

      var resolved = resolvePriceCents({
        basePriceCents: baseCents,
        eventId: eventId,
        state: state,
        city: city,
        cityKey: cityKey,
        venueName: venueName,
        venueHandle: venueHandle,
        variantId: variantId,
        workshopId: workshopId
      });

      if (typeof resolved !== 'number' || !Number.isFinite(resolved) || resolved <= 0) resolved = baseCents;

      if (WB_PRICE_DEBUG && j === 0) {
        try {
          console.log('[WB] updateAllVariantCardPrices sample', {
            eventId: eventId,
            state: state,
            city: city,
            venueName: venueName,
            variantId: variantId,
            baseCents: baseCents,
            resolvedCents: resolved
          });
        } catch (_) {}
      }

      var priceEl = btn.querySelector('[data-variant-price]');
      if (priceEl) priceEl.textContent = formatMoney(resolved);
      var card = btn;
      var resolvedCents = resolved;
      var basePriceCents = baseCents;
      var compareEl = card.querySelector('[data-variant-compare-price]');
      var priceRow = card.querySelector('[data-variant-price-row]');
      if (compareEl) {
        if (resolvedCents < basePriceCents) {
          compareEl.textContent = formatMoney(basePriceCents);
          compareEl.style.display = 'block';
          if (priceRow) priceRow.classList.add('wb-variant-prices--on-sale');
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
          if (priceRow) priceRow.classList.remove('wb-variant-prices--on-sale');
        }
      }
    }
  }

  /** Extract numeric variant ID from GID (gid://shopify/ProductVariant/ID) or return as-is if already numeric. */
  function parseVariantIdFromGid(val) {
    if (val == null || val === '') return null;
    const s = String(val).trim();
    const gidMatch = /^gid:\/\/shopify\/ProductVariant\/(\d+)$/i.exec(s);
    if (gidMatch) return gidMatch[1];
    if (/^\d+$/.test(s)) return s;
    return s;
  }

  /**
   * Sync booking variant selection with the product media gallery (left side).
   * 1) Prefer theme.Variants path: set [data-variant-input] radios from variant JSON, dispatch change.
   * 2) Update master select / hidden id fields (theme uses select[name="id"]).
   * 3) Optional: click media thumbnail when data-variant-media-id is present (fallback).
   */
  function motionTriggerVariantById(variantId) {
    try {
      if (!variantId || !booking) return;
      var vid = String(parseVariantIdFromGid(variantId) || variantId).trim();
      if (!vid) return;

      var sectionId = (booking.dataset && booking.dataset.wbSectionId) ? String(booking.dataset.wbSectionId) : '';
      var sectionRoot = sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
      if (sectionRoot && sectionRoot.closest && sectionRoot.closest('#wb-sheet-body')) sectionRoot = null;
      if (!sectionRoot && booking.closest) {
        var c = booking.closest('[id^="shopify-section-"]');
        if (c && (!c.closest || !c.closest('#wb-sheet-body'))) sectionRoot = c;
      }
      if (!sectionRoot) return;

      var activeBtn = booking.querySelector('.wb-variant-btn[data-variant-id="' + CSS.escape(String(vid)) + '"]')
        || booking.querySelector('.wb-variant-btn[data-variant-id="' + CSS.escape(String(variantId)) + '"]')
        || booking.querySelector('.wb-variant-btn.is-active');
      var mediaId = activeBtn ? String(activeBtn.getAttribute('data-variant-media-id') || '').trim() : '';

      var firedVariantInputs = false;
      var variantJsonEl = sectionRoot.querySelector('[data-variant-json]');
      if (variantJsonEl) {
        var variants;
        try {
          variants = JSON.parse(variantJsonEl.textContent || '[]');
        } catch (e) {
          variants = [];
        }
        var vMatch = null;
        for (var vi = 0; vi < variants.length; vi++) {
          if (String(variants[vi].id) === vid) {
            vMatch = variants[vi];
            break;
          }
        }
        if (vMatch) {
          var optKeys = ['option1', 'option2', 'option3'];
          var lastChecked = null;
          for (var oi = 0; oi < optKeys.length; oi++) {
            var ok = optKeys[oi];
            var oval = vMatch[ok];
            if (oval == null || String(oval).trim() === '') continue;
            var radios = sectionRoot.querySelectorAll('input[type="radio"][data-variant-input][data-index="' + ok + '"]');
            if (!radios || !radios.length) continue;
            radios.forEach(function (inp) {
              var isMatch = String(inp.value) === String(oval);
              inp.checked = isMatch;
              if (isMatch) lastChecked = inp;
            });
          }
          if (lastChecked) {
            lastChecked.dispatchEvent(new Event('change', { bubbles: true }));
            firedVariantInputs = true;
          }
        }
      }

      sectionRoot.querySelectorAll('form[id*="product-form-"] input[name="id"], form[id*="product-form-"] select[name="id"]').forEach(function (el) {
        if (!el) return;
        if (String(el.value) !== vid) el.value = vid;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });

      var masterSelect = sectionRoot.querySelector('select[data-product-select], form.product-single__form select[name="id"]');
      if (masterSelect && String(masterSelect.value) !== vid) {
        masterSelect.value = vid;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (firedVariantInputs || !mediaId) return;

      var mediaSelector = sectionId
        ? '[data-media-id="' + sectionId + '-' + mediaId + '"], #postion-image-' + sectionId + '-' + mediaId
        : '[data-media-id$="-' + mediaId + '"], [id$="-' + mediaId + '"]';
      var mediaEl = sectionRoot.querySelector(mediaSelector);
      if (!mediaEl) return;

      var clickTarget = mediaEl.querySelector('button, a, img') || mediaEl;
      if (clickTarget && clickTarget.dispatchEvent) {
        clickTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
      mediaEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    } catch (e) {
      if (window.__WB_DIAG__) console.warn('[WB] motionTriggerVariantById sync failed', e);
    }
  }

  // REMOVED: Webhook-based capacity checks (commented out)
  // const CAPACITY_CHECK_URL = 'https://workshop-capacity-webhook-production.up.railway.app/capacity/check';
  // async function checkWorkshopCapacity(eventId, requestedQuantity) { ... }
  // async function fetchEventCapacity(eventId, requestedQuantity = 1) { ... }
  // async function validateQuantityAgainstCapacity(quantity) { ... }

  /** Collect all keys containing "capacity" from an object (dataset or event payload). */
  function pickCapacityFields(obj) {
    if (!obj || typeof obj !== 'object') return {};
    var out = {};
    try {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && /capacity/i.test(key)) {
          out[key] = obj[key];
        }
      }
    } catch (e) {}
    return out;
  }

  // Helper: Get remaining capacity from event card (metaobject-based, no webhook).
  // Desktop / venue cards (.workshop-event-card): missing or invalid capacity → 0 (unchanged legacy behavior).
  // Mobile "all workshops" list cards (.wb-all__event-card): missing/invalid → null so UI is not falsely sold-out.
  function getRemainingCapacityFromCard(card) {
    if (!card) return 0;

    var isWbAllList = card.classList && card.classList.contains('wb-all__event-card');

    const raw = card.dataset.capacityRemaining;
    if (raw == null || String(raw).trim() === '') {
      if (isWbAllList) {
        if (window.__WB_DIAG__) console.warn('[CAPACITY] Missing capacity on wb-all card — not blocking UI');
        return null;
      }
      return 0;
    }

    const capacity = Number(raw);

    if (!Number.isFinite(capacity) || capacity < 0) {
      if (window.__WB_DIAG__) console.warn('[CAPACITY] Invalid capacity:', raw);
      if (isWbAllList) return null;
      return 0;
    }

    return capacity;
  }

  function wbRenderCapacityBadge(rootEl, remaining, total) {
    try {
      var badge = rootEl && rootEl.querySelector ? rootEl.querySelector('[data-wb-capacity-badge]') : null;
      if (!badge) {
        badge = document.querySelector('#wb-sheet.wb-all__sheet--mobile-compact [data-wb-capacity-badge][data-wb-hoisted-header]');
      }
      if (!badge) return;

      var labelEl = badge.querySelector('.wb-capacity-label');
      var numEl = badge.querySelector('.wb-capacity-num');
      var pctEl = badge.querySelector('.wb-capacity-pct');
      if (numEl) {
        var remStr = '—';
        if (remaining != null && String(remaining).trim() !== '') {
          var rn = Number(remaining);
          if (Number.isFinite(rn)) remStr = String(rn);
        }
        var totStr = (total != null && total !== '' && Number(total) > 0) ? String(total) : '—';
        numEl.textContent = remStr + ' / ' + totStr;
      }

      var prog = badge.querySelector('.wb-capacity-progress');
      if (!prog) return;

      var rem = remaining == null || String(remaining).trim() === '' ? NaN : Number(remaining);
      var tot = Number(total);

      if (Number.isFinite(rem) && Number.isFinite(tot) && tot > 0) {
        var pct = (rem / tot) * 100;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        var pctRound = Math.round(pct);
        if (pctEl) pctEl.textContent = String(pctRound) + '%';

        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = String(100 - pct);
        if (pct > 66) {
          badge.setAttribute('data-capacity-state', 'high');
          if (labelEl) labelEl.textContent = 'Plenty';
          prog.style.stroke = '#1fbf6a';
        } else if (pct > 33) {
          badge.setAttribute('data-capacity-state', 'medium');
          if (labelEl) labelEl.textContent = 'Limited';
          prog.style.stroke = '#f4b400';
        } else {
          var soldOut = pct <= 0;
          badge.setAttribute('data-capacity-state', soldOut ? 'soldout' : 'low');
          if (labelEl) labelEl.textContent = soldOut ? 'Sold out' : 'Almost full';
          prog.style.stroke = '#e53935';
        }
      } else {
        badge.setAttribute('data-capacity-state', 'unknown');
        if (labelEl) labelEl.textContent = 'Capacity';
        if (pctEl) pctEl.textContent = '--%';
        prog.style.strokeDasharray = '100 100';
        prog.style.strokeDashoffset = '100';
        prog.style.stroke = 'rgba(0,0,0,0.2)';
      }
    } catch (e) {}
  }

  function wbOpenStickyPanel(bookingBox) {
    try {
      if (!bookingBox) return;
      var root =
        bookingBox.closest('[data-ai-wb-sticky]') ||
        bookingBox.closest('[data-wb-panel]') ||
        document.querySelector('[data-ai-wb-sticky]');
      if (!root) return;
      var toggle = root.querySelector('[data-ai-wb-sticky-toggle]');
      var body = root.querySelector('[data-ai-wb-sticky-body]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      root.classList.add('wb-sticky-open');
      root.classList.remove('wb-panel--collapsed');
      root.classList.add('wb-panel--expanded');
      if (body) {
        body.style.maxHeight = '';
        body.style.overflow = '';
        body.classList.remove('pdp-wb-hidden');
      }
    } catch (e) {}
  }

  // Validate seat selection (soft check using metaobject capacity)
  function validateSeatSelection() {
    /* Wizard uses popup datetime + wbw hints; no legacy capacity-warning UI here. */
    if (booking && booking.classList && booking.classList.contains('wb-wizard')) return;

    var sheetBodyEl = document.getElementById('wb-sheet-body');
    var hasSheetBookingUi = sheetBodyEl && sheetBodyEl.querySelector('.pdp-workshop-booking');
    /**
     * "Book all" list + bottom sheet: use wb-all card when THIS init's booking lives in #wb-sheet-body.
     * Do not use sheetBookingInDom === booking (reference can differ across inits); do not require overlay class.
     */
    var inSheetContext = !!(booking && booking.closest && booking.closest('#wb-sheet-body'));
    var listSel =
      hasSheetBookingUi && inSheetContext
        ? document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
          document.querySelector('.wb-all__event-card.is-selected')
        : null;
    const selectedCard =
      (eventsRoot && eventsRoot.querySelector('.workshop-event-card.is-selected')) ||
      listSel ||
      (!eventsRoot ? document.querySelector('.workshop-event-card.is-selected') : null);
    if (!selectedCard) {
      // No selection - disable buttons and hide warning
      const warningEl = bookingBox ? bookingBox.querySelector('[data-capacity-warning]') : null;
      const addBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;
      const buyBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;
      if (warningEl) warningEl.style.display = 'none';
      if (addBtn) addBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;
      return;
    }

    const variantId = (selectedCard.dataset.variantId || '').trim();
    if (!wbIsEventBookable(selectedCard)) {
      const warningEl = bookingBox ? bookingBox.querySelector('[data-capacity-warning]') : null;
      const addBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;
      const buyBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;
      if (warningEl) {
        warningEl.textContent = 'This workshop is sold out.';
        warningEl.style.display = 'block';
      }
      if (addBtn) { addBtn.disabled = true; addBtn.style.cursor = 'not-allowed'; }
      if (buyBtn) { buyBtn.disabled = true; buyBtn.style.cursor = 'not-allowed'; }
      return;
    }
    const notBookable = selectedCard.getAttribute('data-not-bookable') === '1' || variantId === 'none';
    if (notBookable) {
      const warningEl = bookingBox ? bookingBox.querySelector('[data-capacity-warning]') : null;
      const addBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;
      const buyBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;
      if (warningEl) {
        warningEl.textContent = 'Not bookable (missing variants).';
        warningEl.style.display = 'block';
      }
      if (addBtn) { addBtn.disabled = true; addBtn.style.cursor = 'not-allowed'; }
      if (buyBtn) { buyBtn.disabled = true; buyBtn.style.cursor = 'not-allowed'; }
      return;
    }

    const remainingCapacity = getRemainingCapacityFromCard(selectedCard);

    const qtyInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
    const requested = Math.max(1, Number((qtyInput && qtyInput.value) || 1));

    const warningEl = bookingBox ? bookingBox.querySelector('[data-capacity-warning]') : null;
    const addBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;
    const buyBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;

    if (remainingCapacity != null && remainingCapacity <= 0) {
      if (warningEl) {
        warningEl.textContent = 'This workshop is sold out.';
        warningEl.style.display = 'block';
      }
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.style.backgroundColor = '#e0e0e0';
        addBtn.style.color = '#9e9e9e';
        addBtn.style.cursor = 'not-allowed';
      }
      if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.style.backgroundColor = '#e0e0e0';
        buyBtn.style.color = '#9e9e9e';
        buyBtn.style.cursor = 'not-allowed';
      }
      return;
    }

    if (remainingCapacity != null && requested > remainingCapacity) {
      if (warningEl) {
        warningEl.textContent = `This workshop has only ${remainingCapacity} seats remaining. You can't add more seats.`;
        warningEl.style.display = 'block';
      }
      if (qtyInput) qtyInput.value = String(remainingCapacity);
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.style.backgroundColor = '#e0e0e0';
        addBtn.style.color = '#9e9e9e';
        addBtn.style.cursor = 'not-allowed';
      }
      if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.style.backgroundColor = '#e0e0e0';
        buyBtn.style.color = '#9e9e9e';
        buyBtn.style.cursor = 'not-allowed';
      }
      return;
    }

    if (variantSelect && !(variantSelect.value || '').toString().trim()) {
      ensureVariantUiSyncedFromSelect();
    }

    // Valid selection - enable buttons
    if (bookingBox) bookingBox.classList.remove('wb-no-event-selected');
    if (warningEl) warningEl.style.display = 'none';
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.style.backgroundColor = '#042B39';
      addBtn.style.color = '#ffffff';
      addBtn.style.cursor = 'pointer';
    }
    if (buyBtn) {
      buyBtn.disabled = false;
      buyBtn.style.backgroundColor = '#00A99E';
      buyBtn.style.color = '#ffffff';
      buyBtn.style.cursor = 'pointer';
    }
  }

  /** AUDIT: Writes bottom-left resolved price to [data-last-price]. Inputs: card (event), getSelectedVariantPriceCents(), getSelectedVariantId(), booking.dataset.productId. Uses resolvePriceCents(); invalid/<=0 shows "—". */
  function showPreviewPrice(card) {
    const lp =
      (booking && booking.querySelector('[data-last-price]')) ||
      (bookingBox && bookingBox.querySelector('[data-last-price]')) ||
      document.querySelector('[data-last-price]');
    if (!lp) return;

    try {
      // Get all required data for price resolution (same as Add to Cart)
      const basePriceCents = getSelectedVariantPriceCents();
      if (!basePriceCents || Number.isNaN(basePriceCents)) {
        setLastPriceElDisplay(lp, null, null);
        return;
      }

      const eventId = (card.dataset.eventMetaobjectGid || card.dataset.eventId || '').toString().trim();
      const state = card.dataset.state || '';
      const city = card.dataset.city || '';
      const cityKey = (card.dataset.cityKey || '').toString().trim();
      const venueName = (card.dataset.venueName || '').toString().trim();
      const venueHandle = (card.dataset.venueHandle || '').toString().trim();
      const variantId = getSelectedVariantId();
      const workshopId = booking?.dataset?.productId;

      // Use the SAME resolvePriceCents() logic as Add to Cart
      const resolvedCents = resolvePriceCents({
        basePriceCents: basePriceCents,
        eventId: eventId,
        state: state,
        city: city,
        cityKey: cityKey,
        venueName: venueName,
        venueHandle: venueHandle,
        variantId: variantId,
        workshopId: workshopId,
      });

      // Display the resolved price (UI-only, no state/dataset writes)
      if (resolvedCents && Number.isFinite(resolvedCents) && resolvedCents > 0) {
        setLastPriceElDisplay(lp, basePriceCents, resolvedCents);
      } else {
        setLastPriceElDisplay(lp, null, null);
      }
    } catch (err) {
      if (window.__WB_DIAG__) console.warn('Workshop: Preview price calculation failed', err);
      setLastPriceElDisplay(lp, null, null);
    }
  }

  function buildSelectionDetailFromCard(card) {
    if (!card) return null;
    var basePriceCents = getSelectedVariantPriceCents();
    if (basePriceCents == null || Number.isNaN(basePriceCents)) return null;
    var eventId = (card.dataset.eventMetaobjectGid || card.dataset.eventId || '').toString().trim();
    var state = card.dataset.state || '';
    var city = card.dataset.city || '';
    var cityKey = (card.dataset.cityKey || '').toString().trim();
    var venueName = (card.dataset.venueName || '').trim();
    var venueHandle = (card.dataset.venueHandle || '').toString().trim();
    var variantId = getSelectedVariantId();
    var workshopId = booking && booking.dataset && booking.dataset.productId;
    var resolvedCents = resolvePriceCents({
      basePriceCents: basePriceCents,
      eventId: eventId,
      state: state,
      city: city,
      cityKey: cityKey,
      venueName: venueName,
      venueHandle: venueHandle,
      variantId: variantId,
      workshopId: workshopId
    });
    var activeBtn = booking && booking.querySelector('.wb-variant-btn.is-active');
    var variantImgEl = activeBtn && activeBtn.querySelector('.wb-variant-img img');
    var productImgEl = document.querySelector('[data-product-image-main] img');
    return {
      product_handle: (booking && booking.dataset && booking.dataset.productHandle) || (card.dataset.productHandle || '').trim(),
      product_image: (booking && booking.getAttribute('data-product-image-url')) || (productImgEl && (productImgEl.currentSrc || productImgEl.src)) || null,
      variant_id: variantId,
      variant_title: (activeBtn && activeBtn.dataset.variantTitle) || '',
      variant_image: (variantImgEl && (variantImgEl.currentSrc || variantImgEl.src)) || null,
      price_cents: (resolvedCents && Number.isFinite(resolvedCents) && resolvedCents > 0) ? resolvedCents : null,
      currency: (typeof window !== 'undefined' && window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
      venue_name: venueName,
      city_label: city,
      date_label: (card.dataset.dateLabel || '').trim(),
      time_label: (card.dataset.timeLabel || '').trim(),
      starts_at_iso: (card.dataset.startsAt || '').trim() || null
    };
  }

  function wbDispatchSelection(detail) {
    try {
      window.__wbSelection = detail;
      document.dispatchEvent(new CustomEvent('wb:selection', { detail: detail || {} }));
    } catch (e) {}
  }

  function wbApplyEventsStepHeading(headerEl, stepNum, title, hint) {
    if (!headerEl) return;
    var titleEl = headerEl.querySelector('[data-wb-step-title]');
    var hintEl = headerEl.querySelector('[data-wb-step-hint]');
    if (!titleEl && !hintEl) {
      headerEl.textContent = title || '';
      return;
    }
    if (titleEl) titleEl.textContent = title || '';
    if (hintEl) {
      var h = hint != null && String(hint).trim() ? String(hint).trim() : '';
      hintEl.textContent = h;
      hintEl.style.display = h ? '' : 'none';
    }
  }

  function wbGetFirstBookableVenueCardInOpenGroup(root) {
    if (!root) return null;
    var groups = root.querySelectorAll('.wb-venue-group');
    for (var i = 0; i < groups.length; i++) {
      var t = groups[i].querySelector('[data-workshop-group-toggle]');
      if (!t || t.getAttribute('aria-expanded') !== 'true') continue;
      if (__wbLive.lockedVenueRefId) {
        var lockedCards = groups[i].querySelectorAll('.wb-venue-card');
        for (var lk = 0; lk < lockedCards.length; lk++) {
          if (String(lockedCards[lk].getAttribute('data-venue-ref-id') || '').trim() !== __wbLive.lockedVenueRefId) continue;
          if (lockedCards[lk].querySelector('[data-workshop-venue-date]')) return lockedCards[lk];
        }
      }
      var cards = groups[i].querySelectorAll('.wb-venue-card');
      for (var j = 0; j < cards.length; j++) {
        if (cards[j].querySelector('[data-workshop-venue-date]')) return cards[j];
      }
    }
    return null;
  }

  function wbLockVenueContextFromCard(venueCard) {
    if (!venueCard) return;
    var refId = String(venueCard.getAttribute('data-venue-ref-id') || '').trim();
    if (refId) __wbLive.lockedVenueRefId = refId;
    var group = venueCard.closest ? venueCard.closest('.wb-venue-group') : null;
    if (!group) return;
    var groupKey = String(group.getAttribute('data-workshop-venue-group') || '').trim();
    if (groupKey) __wbLive.lockedVenueGroupKey = groupKey;
  }

  function wbRestoreVenueContext() {
    if (!eventsRoot) return;
    var targetGroup = null;
    if (__wbLive.lockedVenueGroupKey) {
      try {
        if (typeof CSS !== 'undefined' && CSS.escape) {
          targetGroup = eventsRoot.querySelector('.wb-venue-group[data-workshop-venue-group="' + CSS.escape(__wbLive.lockedVenueGroupKey) + '"]');
        }
      } catch (_) {}
      if (!targetGroup) {
        var allGroups = eventsRoot.querySelectorAll('.wb-venue-group');
        for (var gi = 0; gi < allGroups.length; gi++) {
          if (String(allGroups[gi].getAttribute('data-workshop-venue-group') || '').trim() === __wbLive.lockedVenueGroupKey) {
            targetGroup = allGroups[gi];
            break;
          }
        }
      }
    }
    if (!targetGroup && __wbLive.lockedVenueRefId) {
      var cards = eventsRoot.querySelectorAll('.wb-venue-card');
      for (var ci = 0; ci < cards.length; ci++) {
        if (String(cards[ci].getAttribute('data-venue-ref-id') || '').trim() !== __wbLive.lockedVenueRefId) continue;
        targetGroup = cards[ci].closest ? cards[ci].closest('.wb-venue-group') : null;
        if (targetGroup) break;
      }
    }
    if (!targetGroup) return;
    var header = targetGroup.querySelector('[data-workshop-group-toggle]') || targetGroup.querySelector('.wb-group-toggle');
    var body = targetGroup.querySelector('.wb-group-body');
    if (header && body && header.getAttribute('aria-expanded') !== 'true') {
      var closeFn = (typeof window !== 'undefined' && window.WorkshopBookingLocation &&
        window.WorkshopBookingLocation.closeAllVenueCardsExcept) || null;
      var expandFn = (typeof window !== 'undefined' && window.WorkshopBookingLocation &&
        window.WorkshopBookingLocation.expandBody) || null;
      if (typeof closeFn === 'function') closeFn(eventsRoot, targetGroup);
      if (typeof expandFn === 'function') expandFn(body, header);
    }
  }

  function wbRefreshBookingGuideUi() {
    function wbUpdateCollapsedPanelSelectionSummary() {
      var selectedCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
      if (!selectedCard) return false;
      var venueText = String(selectedCard.getAttribute('data-venue-name') || '').trim();
      var dateText = String(selectedCard.getAttribute('data-date-label') || '').trim() ||
        wstFormatDateKey(selectedCard.getAttribute('data-date-key') || '');
      var timeText = String(selectedCard.getAttribute('data-time-label') || '').trim();
      var variantText = String(wstGetActiveVariantName() || '').trim();
      var priceText = '';
      if (lastPriceEl) {
        var currentPriceEl = lastPriceEl.querySelector('[data-last-price-current]');
        priceText = normalize(currentPriceEl ? currentPriceEl.textContent : lastPriceEl.textContent).replace(/\s+/g, ' ').trim();
        if (priceText === '—' || priceText === '-') priceText = '';
      }

      var isMobile = false;
      try {
        isMobile = !!(window && window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
      } catch (_) {}

      // Mobile header cleanup: hide venue + variant + price in collapsed header summary.
      // Keep date/time only (expanded summary below still shows address/datetime).
      var lineOne = (isMobile ? [dateText, timeText] : [venueText, dateText, timeText]).filter(Boolean).join(' · ').trim();
      var lineTwo = (isMobile ? [] : [variantText, priceText]).filter(Boolean).join(' · ').trim();

      if (panelTitle) panelTitle.textContent = lineOne || 'Session selected';
      if (panelHintEl) {
        panelHintEl.textContent = lineTwo;
        if (lineTwo) {
          panelHintEl.classList.remove('pdp-wb-hidden');
          panelHintEl.setAttribute('aria-hidden', 'false');
        } else {
          panelHintEl.classList.add('pdp-wb-hidden');
          panelHintEl.setAttribute('aria-hidden', 'true');
        }
      }
      return true;
    }

    var headerEl = booking.querySelector('[data-available-events-header]');
    var variantGuide = bookingBox ? bookingBox.querySelector('[data-wb-variant-guide]') : null;
    var selectedEventCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
    var hasEventSelected =
      !!selectedEventCard ||
      !!(selectedEventIdInput && String(selectedEventIdInput.value || '').trim());
    if (variantGuide) {
      if (hasEventSelected) {
        variantGuide.classList.remove('pdp-wb-hidden');
        variantGuide.setAttribute('aria-hidden', 'false');
      } else {
        variantGuide.classList.add('pdp-wb-hidden');
        variantGuide.setAttribute('aria-hidden', 'true');
      }
    }

    if (booking && booking.classList && booking.classList.contains('wb-wizard')) {
      var flatHeaderEl = booking.querySelector('[data-available-events-header]');
      if (flatHeaderEl) {
        wbApplyEventsStepHeading(flatHeaderEl, 1, 'Choose your Venue', 'Tap a venue to continue');
      }
      return;
    }

    var missingVenueShell = !eventsRoot || !eventsRoot.querySelector('.wb-venue-group');
    if (!useLocationFirst || missingVenueShell) {
      var legacyHasStructure = !!(headerEl && headerEl.querySelector && headerEl.querySelector('[data-wb-step-title]'));
      if (legacyHasStructure) {
        if (!hasEventSelected) {
          wbApplyEventsStepHeading(headerEl, 1, 'Choose your session', 'Use the filters or list above to find a time slot.');
          if (panelTitle) panelTitle.textContent = 'Book your workshop';
          if (panelHintEl) {
            panelHintEl.textContent = 'Complete the steps above to pick a time slot.';
            panelHintEl.classList.remove('pdp-wb-hidden');
            panelHintEl.setAttribute('aria-hidden', 'false');
          }
        } else {
          wbApplyEventsStepHeading(
            headerEl,
            4,
            '',
            ''
          );
          if (!wbUpdateCollapsedPanelSelectionSummary()) {
            if (panelTitle) panelTitle.textContent = 'Workshop selected';
            if (panelHintEl) {
              panelHintEl.textContent = '';
              panelHintEl.classList.add('pdp-wb-hidden');
              panelHintEl.setAttribute('aria-hidden', 'true');
            }
          }
        }
      }
      if (bookingHint) {
        if (!hasEventSelected) {
          bookingHint.classList.remove('pdp-wb-hidden');
          bookingHint.textContent = 'Select a venue and session to see details';
        } else {
          bookingHint.classList.add('pdp-wb-hidden');
        }
      }
      return;
    }

    if (hasEventSelected) {
      wbApplyEventsStepHeading(
        headerEl,
        4,
        'Choose a Venue',
        'Venues are shown for your location. Open one below to review or change your session.'
      );
      if (!wbUpdateCollapsedPanelSelectionSummary()) {
        if (panelTitle) panelTitle.textContent = 'Workshop selected';
        if (panelHintEl) {
          panelHintEl.textContent = '';
          panelHintEl.classList.add('pdp-wb-hidden');
          panelHintEl.setAttribute('aria-hidden', 'true');
        }
      }
      if (bookingHint) bookingHint.classList.add('pdp-wb-hidden');
      return;
    }

    var openToggle = eventsRoot.querySelector('[data-workshop-group-toggle][aria-expanded="true"]');
    if (!openToggle) {
      wbApplyEventsStepHeading(
        headerEl,
        1,
        'Choose a Venue',
        'Venues are shown for your location. Open one below for sessions or waitlist.'
      );
      if (panelTitle) panelTitle.textContent = 'Book your workshop';
      if (panelHintEl) {
        panelHintEl.textContent = 'Expand a venue below to see times or waitlist.';
        panelHintEl.classList.remove('pdp-wb-hidden');
        panelHintEl.setAttribute('aria-hidden', 'false');
      }
      if (bookingHint) {
        bookingHint.classList.remove('pdp-wb-hidden');
        bookingHint.textContent = 'Select a venue and session to see details';
      }
      return;
    }

    var vCard = wbGetFirstBookableVenueCardInOpenGroup(eventsRoot);
    if (!vCard) {
      wbApplyEventsStepHeading(headerEl, 2, 'Next steps', 'Try another venue or use the waitlist if no session dates are open yet.');
      if (panelTitle) panelTitle.textContent = 'Book your workshop';
      if (panelHintEl) {
        panelHintEl.textContent = 'No bookable sessions at these venues yet.';
        panelHintEl.classList.remove('pdp-wb-hidden');
        panelHintEl.setAttribute('aria-hidden', 'false');
      }
      if (bookingHint) {
        bookingHint.classList.remove('pdp-wb-hidden');
        bookingHint.textContent = 'Select a venue and session to see details';
      }
      return;
    }

    var dateTouched = vCard.getAttribute('data-wb-date-touched') === '1';
    if (!dateTouched) {
      wbApplyEventsStepHeading(headerEl, 2, 'Choose your date&session', 'Confirm the day, then tap an available start time.');
      if (panelTitle) panelTitle.textContent = 'Pick a session';
      if (panelHintEl) {
        panelHintEl.textContent = 'Select a date and start time on the venue card above.';
        panelHintEl.classList.remove('pdp-wb-hidden');
        panelHintEl.setAttribute('aria-hidden', 'false');
      }
    } else {
      wbApplyEventsStepHeading(headerEl, 3, 'Choose your time', 'Tap an available start time to lock in your session.');
      if (panelTitle) panelTitle.textContent = 'Pick a time slot';
      if (panelHintEl) {
        panelHintEl.textContent = 'Times appear under the date you selected.';
        panelHintEl.classList.remove('pdp-wb-hidden');
        panelHintEl.setAttribute('aria-hidden', 'false');
      }
    }
    if (bookingHint) {
      bookingHint.classList.remove('pdp-wb-hidden');
      bookingHint.textContent = 'Select a venue and session to see details';
    }
  }

  function clearEventSelection() {
    if (eventsRoot) {
      eventsRoot.querySelectorAll('.workshop-event-card.is-selected').forEach((el) => {
        el.classList.remove('is-selected');
        el.style.boxShadow = '';
        el.style.transform = '';
      });
    }
    if (selectedEventIdInput) selectedEventIdInput.value = '';
    if (bookingBox) bookingBox.classList.add('wb-no-event-selected');
    if (bookingHint) bookingHint.classList.remove('pdp-wb-hidden');
    if (selectedSummary) selectedSummary.classList.add('pdp-wb-hidden');
    if (bookNowBtn) {
      bookNowBtn.disabled = true;
      bookNowBtn.style.backgroundColor = '#e0e0e0';
      bookNowBtn.style.color = '#9e9e9e';
      bookNowBtn.style.cursor = 'not-allowed';
    }
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.style.backgroundColor = '#e0e0e0';
      addToCartBtn.style.color = '#9e9e9e';
      addToCartBtn.style.cursor = 'not-allowed';
    }
    if (summaryStatus) { summaryStatus.textContent = ''; summaryStatus.classList.add('pdp-wb-hidden'); }
    // Clear global selection state and capacity
    window.__WORKSHOP_SELECTION__ = null;
    window.__WORKSHOP_CAPACITY__ = null;
    wbDispatchSelection({});
    var crossHost = booking && booking.querySelector('#wb-cross-product-booking');
    if (crossHost) { crossHost.innerHTML = ''; crossHost.style.display = 'none'; }
    var old = booking && booking.querySelector('[data-wb-also-available]');
    if (old) old.remove();
    // Hide capacity warning and helper text
    const warningEl = bookingBox ? bookingBox.querySelector('[data-workshop-capacity-warning]') : null;
    const seatsAvailableEl = bookingBox ? bookingBox.querySelector('[data-workshop-seats-available]') : null;
    if (warningEl) {
      warningEl.classList.add('hidden');
    }
    if (seatsAvailableEl) {
      seatsAvailableEl.classList.add('hidden');
    }
    
    // Reset quantity input max attribute
    const quantityInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
    if (quantityInput) {
      quantityInput.removeAttribute('max');
    }
    applyVariantCardVisibility(null);
    window.__WB_URL_EVENT_ID_NUMERIC__ = '';
    updateUrlForEventId(null);
    try {
      wbRefreshBookingGuideUi();
    } catch (_) {}
    wstUpdate(1, {});
  }

  /**
   * Get set of allowed variant IDs (numeric string) from event card.
   * Uses card._wbEv.available_variants or data-available-variants. Falls back to single variant_id if no list.
   * Returns null to mean "show all".
   */
  function getAvailableVariantIdsFromCard(card) {
    if (!card) return null;
    var raw = null;
    if (card._wbEv && Array.isArray(card._wbEv.available_variants) && card._wbEv.available_variants.length > 0) {
      raw = card._wbEv.available_variants;
    } else if (card._wbEv && card._wbEv.available_variants) {
      raw = Array.isArray(card._wbEv.available_variants) ? card._wbEv.available_variants : [card._wbEv.available_variants];
    }
    if (!raw && (card.getAttribute('data-available-variants') || (card.dataset && card.dataset.availableVariants))) {
      var attr = card.getAttribute('data-available-variants') || (card.dataset && card.dataset.availableVariants) || '';
      try { raw = JSON.parse(attr); } catch (e) { raw = null; }
    }
    if (raw && Array.isArray(raw) && raw.length > 0) {
      var set = new Set();
      for (var i = 0; i < raw.length; i++) {
        var it = raw[i];
        var id = null;
        if (it != null) {
          if (typeof it === 'number' || (typeof it === 'string' && /^\d+$/.test(String(it)))) id = String(it);
          else if (it.id != null) id = String(parseVariantIdFromGid(it.id) || it.id);
          else if (it.variant_id != null) id = String(parseVariantIdFromGid(it.variant_id) || it.variant_id);
        }
        if (id) set.add(id);
      }
      if (set.size) return set;
    }
    var singleVariantId = (card.dataset.variantId || card.dataset.variantGid || '').toString().trim();
    if (singleVariantId && singleVariantId !== 'none') {
      var one = parseVariantIdFromGid(singleVariantId);
      if (one) return new Set([String(one)]);
    }
    return null;
  }

  function applyVariantCardVisibility(allowedIds) {
    var btns = booking ? booking.querySelectorAll('.wb-variant-btn') : [];
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var vid = (btn.dataset.variantId || '').toString().trim();
      var numericId = parseVariantIdFromGid(vid) || vid;
      var show = !allowedIds || allowedIds.has(vid) || allowedIds.has(String(numericId));
      if (show) {
        btn.classList.remove('wb-variant-unavailable');
        btn.removeAttribute('disabled');
        btn.style.display = '';
      } else {
        btn.classList.add('wb-variant-unavailable');
        btn.setAttribute('disabled', '');
        btn.style.display = '';
      }
      btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if (allowedIds && variantSelect) {
      var activeBtn = booking && booking.querySelector('.wb-variant-btn.is-active');
      if (activeBtn && activeBtn.classList.contains('wb-variant-unavailable')) {
        var firstVisible = booking && Array.prototype.find.call(booking.querySelectorAll('.wb-variant-btn'), function (b) { return !b.classList.contains('wb-variant-unavailable'); });
        if (firstVisible) {
          var firstId = (firstVisible.dataset.variantId || '').toString().trim();
          if (firstId) {
            variantSelect.value = firstId;
            booking.querySelectorAll('.wb-variant-btn').forEach(function (b) {
              b.classList.toggle('is-active', b === firstVisible);
            });
            motionTriggerVariantById(firstId);
          }
        }
      }
    }
  }

  /** After programmatic variant changes, ensure hidden input + .is-active match a visible tile (no extra tap). */
  function ensureVariantUiSyncedFromSelect() {
    if (!booking || !variantSelect) return;
    function firstVisibleVariantBtn() {
      var btns = booking.querySelectorAll('.wb-variant-btn');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].style.display !== 'none') return btns[i];
      }
      return null;
    }
    var val = (variantSelect.value || '').toString().trim();
    if (!val) {
      var fv = firstVisibleVariantBtn();
      if (fv) {
        var fid = (fv.dataset.variantId || '').toString().trim();
        var parsed = parseVariantIdFromGid(fid) || fid;
        if (parsed) variantSelect.value = String(parsed);
        booking.querySelectorAll('.wb-variant-btn').forEach(function (b) {
          b.classList.toggle('is-active', b === fv);
        });
      }
      return;
    }
    if (booking.querySelector('.wb-variant-btn.is-active')) return;
    var btn = null;
    try {
      if (typeof CSS !== 'undefined' && CSS.escape) {
        btn = booking.querySelector('.wb-variant-btn[data-variant-id="' + CSS.escape(val) + '"]');
      }
    } catch (e) {}
    if (!btn) {
      var all = booking.querySelectorAll('.wb-variant-btn');
      for (var j = 0; j < all.length; j++) {
        var vv = (all[j].dataset.variantId || '').toString().trim();
        var nv = parseVariantIdFromGid(vv) || vv;
        if (String(nv) === String(val)) {
          btn = all[j];
          break;
        }
      }
    }
    if (btn && btn.style.display !== 'none') {
      booking.querySelectorAll('.wb-variant-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      return;
    }
    var fv2 = firstVisibleVariantBtn();
    if (fv2) {
      var fid2 = (fv2.dataset.variantId || '').toString().trim();
      var p2 = parseVariantIdFromGid(fid2) || fid2;
      if (p2) variantSelect.value = String(p2);
      booking.querySelectorAll('.wb-variant-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === fv2);
      });
    }
  }

  function showSoldOutItemWarning() {
    var warningEl = bookingBox ? bookingBox.querySelector('[data-capacity-warning]') : null;
    if (warningEl) warningEl.style.display = 'none';
    showSoldOutCapacityModal();
    if (summaryStatus) {
      summaryStatus.textContent = 'SOLD OUT';
      summaryStatus.classList.remove('pdp-wb-hidden');
    }
    if (eventsRoot) {
      eventsRoot.querySelectorAll('.workshop-event-card.is-selected').forEach(function (el) {
        el.classList.remove('is-selected');
      });
    }
    if (bookingBox) bookingBox.classList.add('wb-no-event-selected');
    var addBtn = bookingBox ? bookingBox.querySelector('[data-add-to-cart]') : null;
    var buyBtn = bookingBox ? bookingBox.querySelector('[data-book-now]') : null;
    if (addBtn) { addBtn.disabled = true; addBtn.style.cursor = 'not-allowed'; }
    if (buyBtn) { buyBtn.disabled = true; buyBtn.style.cursor = 'not-allowed'; }
  }

  function setEventSelectionFromCard(card) {
    if (!card) return;
    if (wbIsEventSoldOut(card) || !wbIsEventBookable(card)) return;
    var venueCardForLock = card.closest ? card.closest('.wb-venue-card') : null;
    if (venueCardForLock) wbLockVenueContextFromCard(venueCardForLock);

    if (eventsRoot) {
      eventsRoot.querySelectorAll('.workshop-event-card.is-selected').forEach((el) => {
        el.classList.remove('is-selected');
      });
    }
    card.classList.add('is-selected');

    const eventKey = (card.dataset.eventMetaobjectGid || card.dataset.eventId || '').toString().trim();
    const eventId = eventKey;
    const eventHandle = (card.dataset.eventHandle || '').trim();
    const city = card.dataset.city || '';
    const state = card.dataset.state || '';
    const venue = (card.dataset.venueName || '').trim();
    const eventName = (card.dataset.eventName || '').trim();
    const dateLabel = (card.dataset.dateLabel || '').trim();
    const timeLabel = card.dataset.timeLabel || '';
    var datetime = dateLabel && timeLabel ? `${dateLabel} ${timeLabel}`.trim() : (dateLabel || timeLabel);
    if (!datetime) datetime = (card.getAttribute('data-datetime') || '').trim();

    // Store selection state globally (DO NOT calculate price here). eventHandle required for cart.
    window.__WORKSHOP_SELECTION__ = {
      eventId,
      eventHandle,
      city,
      state,
      venue,
      datetime
    };

    if (selectedEventIdInput) selectedEventIdInput.value = eventId;
    var numericEventIdForUrl = extractNumericEventIdForUrl(eventId);
    window.__WB_URL_EVENT_ID_NUMERIC__ = numericEventIdForUrl || '';
    setTimeout(function () {
      updateUrlForEventId(numericEventIdForUrl);
    }, 0);

    if (bookingHint) bookingHint.classList.add('pdp-wb-hidden');
    if (selectedSummary) selectedSummary.classList.remove('pdp-wb-hidden');
    const venueText = (card._wbEv && (card._wbEv.venue_name || card._wbEv.venue || card._wbEv.city)) || venue || '';
    if (summaryVenue) summaryVenue.textContent = venueText;
    // Venue details (address, phone, work hours) with labels – same structure as venue card
    if (summaryVenueDetails) {
      var addr = (card.dataset.venueAddress || '').trim();
      var phone = (card.dataset.venuePhone || '').trim();
      var hours = (card.dataset.venueWorkHours || '').trim();
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
      var phoneEsc = phone ? esc(phone).replace(/"/g, '&quot;') : '';
      var parts = [];
      if (addr) parts.push('<div class="wb-venue-field"><div class="wb-venue-label">Address</div><div class="wb-venue-value wb-venue-addr">' + esc(addr) + '</div></div>');
      if (phone) parts.push('<div class="wb-venue-field"><div class="wb-venue-label">Phone</div><div class="wb-venue-value wb-venue-phone"><a class="wb-venue-phone-link" href="tel:' + phoneEsc + '">' + esc(phone) + '</a></div></div>');
      if (hours) parts.push('<div class="wb-venue-field"><div class="wb-venue-label">Work Hours</div><div class="wb-venue-value wb-venue-work-hours">' + esc(hours) + '</div></div>');
      summaryVenueDetails.innerHTML = parts.join('');
    }
    if (summaryDatetime) summaryDatetime.textContent = datetime || (card.getAttribute('data-datetime') || '').trim();
    if (summaryCapacity) {
      const cap = card.dataset.capacityRemaining;
      var isStandaloneMobile = !!(booking && booking.classList && booking.classList.contains('wb-standalone') && window.matchMedia && window.matchMedia('(max-width: 750px)').matches);
      summaryCapacity.textContent = isStandaloneMobile ? '' : (cap ? `Capacity: ${cap} remaining` : '');
    }
    var remaining = getRemainingCapacityFromCard(card);
    var totalRaw = card.dataset.capacityTotal || card.dataset.capacity;
    var total = totalRaw != null && totalRaw !== '' ? Number(totalRaw) : null;
    wbRenderCapacityBadge(bookingBox, remaining, total);
    wbOpenStickyPanel(bookingBox);
    try {
      var eventObj = card._wbEv || null;
      console.debug('[WB] capacity debug', {
        remainingComputed: remaining,
        totalComputed: total,
        cardDataset: pickCapacityFields(card.dataset),
        eventObjCapacity: pickCapacityFields(eventObj || {})
      });
    } catch (_) {}
    if (summaryStatus) {
      var statusVal = (card.dataset.status || '').toLowerCase().replace(/\s/g, '_');
      if (statusVal && statusVal !== 'active') {
        summaryStatus.textContent = statusVal.toUpperCase();
        summaryStatus.classList.remove('pdp-wb-hidden');
      } else {
        summaryStatus.textContent = '';
        summaryStatus.classList.add('pdp-wb-hidden');
      }
    }

    // Show only variant cards for this event (available_variants or fallback to variant_id)
    var allowedVariantIds = getAvailableVariantIdsFromCard(card);
    applyVariantCardVisibility(allowedVariantIds);

    // Sync Motion native picker + booking panel UI to event's variant
    const rawVariantId = (card.dataset.variantId || card.dataset.variantGid || '').trim();
    if (rawVariantId && rawVariantId !== 'none') {
      const parsedVid = parseVariantIdFromGid(rawVariantId);
      const vidStr = parsedVid != null && String(parsedVid).trim() !== '' ? String(parsedVid).trim() : '';
      if (vidStr) {
        if (variantSelect) variantSelect.value = vidStr;
        booking.querySelectorAll('.wb-variant-btn').forEach(function (b) {
          var bid = (b.dataset.variantId || '').toString().trim();
          var bNum = parseVariantIdFromGid(bid) || bid;
          b.classList.toggle('is-active', String(bNum) === vidStr);
        });
        motionTriggerVariantById(vidStr);
      }
    }
    ensureVariantUiSyncedFromSelect();

    // Show preview price (UI-only, never writes to state or dataset)
    showPreviewPrice(card);
    updateAllVariantCardPrices();

    // Selection summary bar (sticky): dispatch so bar can show venue, date, time, variant, price
    var detail = buildSelectionDetailFromCard(card);
    if (detail) wbDispatchSelection(detail);

    // Cross-product "Also available in:" in Booking panel (under variant tiles)
    renderCrossProductBooking(booking, eventId);

    var selEv = card._wbEv || findEventById(eventId);
    renderAlsoAvailableProducts(selEv, bookingBox || booking);

    // Get capacity from card (metaobject-based, no webhook)
    const remainingCapacity = getRemainingCapacityFromCard(card);
    
    // Update quantity input max attribute and helper text
    const quantityInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
    const seatsAvailableEl = bookingBox ? bookingBox.querySelector('[data-workshop-seats-available]') : null;
    
    if (quantityInput) {
      if (remainingCapacity != null && remainingCapacity > 0) {
        quantityInput.setAttribute('max', String(remainingCapacity));
        if (seatsAvailableEl) {
          seatsAvailableEl.textContent = `Seats available: ${remainingCapacity}`;
          seatsAvailableEl.classList.remove('hidden');
        }
      } else {
        quantityInput.removeAttribute('max');
        if (seatsAvailableEl) seatsAvailableEl.classList.add('hidden');
      }
    }

    // Validate initial quantity (default 1) using metaobject capacity
    // This will enable/disable buttons based on capacity
    validateSeatSelection();
    try {
      wbRefreshBookingGuideUi();
    } catch (_) {}
  }

  function syncInCardSummaryForVenueCard(vc) {
    if (!vc) return;
    var meta = vc.querySelector('[data-wb-venue-meta]');
    if (!meta) return;
    var sel = vc.querySelector('.workshop-event-card.is-selected');
    if (!sel) { meta.innerHTML = ''; return; }
    var dl = (sel.getAttribute('data-date-label') || '').trim();
    var tl = (sel.getAttribute('data-time-label') || '').trim();
    var cap = sel.getAttribute('data-capacity-remaining');
    var line1 = dl || '';
    var line2Parts = [];
    if (tl) line2Parts.push(tl);
    if (cap !== null && cap !== '' && Number(cap) > 0) line2Parts.push(cap + ' seats');
    var line2 = line2Parts.join(' · ');
    meta.innerHTML =
      (line1 ? '<div class="wb-meta-line1">' + line1 + '</div>' : '') +
      (line2 ? '<div class="wb-meta-line2">' + line2 + '</div>' : '');
  }

  function applyFilters() {
    if (useLocationFirst) return;
    const { state, city, variant } = getSelections();

    const cards = Array.from(eventsRoot.querySelectorAll('.workshop-event-card'));
    wbDiag('A_totalCardsInDOM', { count: cards.length });

    cards.forEach((card) => {
      const cardState = normalize(card.dataset.state);
      const cardCity = normalize(card.dataset.city);
      const cardVariantId = (card.dataset.variantId || 'none').toString().trim();

      let ok = true;

      // 1) State – case-insensitive
      if (state && normKey(cardState) !== normKey(state)) ok = false;
      // 2) City – case-insensitive
      if (ok && city && normKey(cardCity) !== normKey(city)) ok = false;
      // 3) Variant – string compare (only after user has changed variant selector)
      if (ok && __wbLive.variantFilterActive && variant && cardVariantId !== 'none' && String(cardVariantId) !== String(variant)) ok = false;

      card.style.display = ok ? '' : 'none';
    });

    sortVisibleByStartsAt();

    // If selected card becomes hidden by filters, clear selection
    const selected = eventsRoot.querySelector('.workshop-event-card.is-selected');
    if (selected && selected.style.display === 'none') {
      clearEventSelection();
    }

    const visibleAfter = Array.from(eventsRoot.querySelectorAll('.workshop-event-card')).filter(function (c) { return window.getComputedStyle(c).display !== 'none'; });
    wbDiag('B_visibleAfterFilters', { count: visibleAfter.length, selections: getSelections() });
  }

  function sortVisibleByStartsAt() {
    const visibleCards = Array.from(eventsRoot.querySelectorAll('.workshop-event-card'))
      .filter((el) => el.style.display !== 'none');

    visibleCards.sort((a, b) => {
      const aTs = parseInt(a.dataset.startsAt || '0', 10);
      const bTs = parseInt(b.dataset.startsAt || '0', 10);
      return aTs - bTs;
    });

    // Re-append in sorted order (stable for visible list)
    visibleCards.forEach((el) => eventsRoot.appendChild(el));
  }

  // ---- Location-first flow: state 0 INIT, 1 LOCATION_RESOLVED, 2 EVENT_TIME_SELECTED, 3 VARIANT_SELECTED ----
  let wbState = 0;
  let allEventsPayload = [];

  function wbInitEventStatusLookup() {
    try {
      var payloadEl = eventsPayloadScript || document.querySelector('[data-workshop-events-payload]');
      var arr = payloadEl ? JSON.parse(payloadEl.textContent || '[]') : [];
      window.__WB_EVENT_STATUS_LOOKUP__ = wbBuildEventStatusLookup(arr);
      if (window.__WB_DIAG__) console.debug('[WB] event status lookup keys', Object.keys(window.__WB_EVENT_STATUS_LOOKUP__ || {}).length);
    } catch (_) {
      window.__WB_EVENT_STATUS_LOOKUP__ = Object.create(null);
    }
  }
  wbInitEventStatusLookup();

  function setWbState(s) {
    wbState = s;
    if (variantWrap) {
      if (s === 2 || s === 3) {
        variantWrap.classList.remove('pdp-wb-hidden');
        variantWrap.setAttribute('aria-hidden', 'false');
      } else {
        variantWrap.classList.add('pdp-wb-hidden');
        variantWrap.setAttribute('aria-hidden', 'true');
      }
    }
    if (s === 3) {
      if (bookingBox) bookingBox.classList.remove('wb-no-event-selected');
      if (lastPriceEl) {
        const sel = eventsRoot.querySelector('.workshop-event-card.is-selected');
        if (sel) showPreviewPrice(sel);
      }
      updateAllVariantCardPrices();
      if (bookNowBtn) { bookNowBtn.disabled = false; bookNowBtn.style.backgroundColor = ''; bookNowBtn.style.color = ''; bookNowBtn.style.cursor = 'pointer'; }
      if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.style.backgroundColor = ''; addToCartBtn.style.color = ''; addToCartBtn.style.cursor = 'pointer'; }
    } else {
      if (bookNowBtn) { bookNowBtn.disabled = true; bookNowBtn.style.backgroundColor = '#e0e0e0'; bookNowBtn.style.color = '#9e9e9e'; bookNowBtn.style.cursor = 'not-allowed'; }
      if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.style.backgroundColor = '#e0e0e0'; addToCartBtn.style.color = '#9e9e9e'; addToCartBtn.style.cursor = 'not-allowed'; }
    }
  }

  var __wbScope = {
    wbUrlHasWizardDeepLink: wbUrlHasWizardDeepLink,
    __WB_WAITLIST_API_URL__: __WB_WAITLIST_API_URL__,
    wbDiag: wbDiag,
    __WBU: __WBU,
    wbNormalizeEventStatus: wbNormalizeEventStatus,
    wbEventCapacityRemaining: wbEventCapacityRemaining,
    wbGetEventStatus: wbGetEventStatus,
    wbExtractEventStatusRaw: wbExtractEventStatusRaw,
    wbEventLookupKeys: wbEventLookupKeys,
    wbBuildEventStatusLookup: wbBuildEventStatusLookup,
    wbLookupEventStatus: wbLookupEventStatus,
    wbIsDisplayStatusBookable: wbIsDisplayStatusBookable,
    wbResolveEventStatus: wbResolveEventStatus,
    wbIsEventSoldOut: wbIsEventSoldOut,
    showSoldOutCapacityModal: showSoldOutCapacityModal,
    wbIsEventBookable: wbIsEventBookable,
    wbShouldHideEvent: wbShouldHideEvent,
    wbPerf: wbPerf,
    __WB_lastHandledPlaceFp: __WB_lastHandledPlaceFp,
    STATE_NAME_TO_CODE: STATE_NAME_TO_CODE,
    normalizeStateCode: normalizeStateCode,
    WB_CATALOG_REGION_NAME_TO_CODE: WB_CATALOG_REGION_NAME_TO_CODE,
    parseCityStateFromFormattedAddress: parseCityStateFromFormattedAddress,
    getPlaceDisplayLabel: getPlaceDisplayLabel,
    _lastPlaceSelectMs: _lastPlaceSelectMs,
    onPlaceSelect: onPlaceSelect,
    ensureDocPlaceListeners: ensureDocPlaceListeners,
    applyWizardPlaceAutocompleteChrome: applyWizardPlaceAutocompleteChrome,
    applyPlaceAutocompleteLightTheme: applyPlaceAutocompleteLightTheme,
    ensurePlaceListeners: ensurePlaceListeners,
    wbSheetBodyEl: wbSheetBodyEl,
    bookingCandidates: bookingCandidates,
    wizardBooking: wizardBooking,
    booking: booking,
    proxyFromRoot: proxyFromRoot,
    PROXY_BASE: PROXY_BASE,
    PROXY_BASE_FALLBACK: PROXY_BASE_FALLBACK,
    eventsPathAttr: eventsPathAttr,
    EVENTS_PATH: EVENTS_PATH,
    venueListSortAttr: venueListSortAttr,
    VENUE_LIST_SORT_MODE: VENUE_LIST_SORT_MODE,
    DEV_MODE: DEV_MODE,
    __wbEvents: __wbEvents,
    joinProxyPath: joinProxyPath,
    fetchWorkshopEvents: fetchWorkshopEvents,
    logBackendRidIfPresent: logBackendRidIfPresent,
    stateInput: stateInput,
    cityInput: cityInput,
    variantSelect: variantSelect,
    variantFilterActive: false,
    __wbLive: __wbLive,
    eventsRoot: eventsRoot,
    eventsPlaceholder: eventsPlaceholder,
    wbwDispatchVenueReset: wbwDispatchVenueReset,
    showWorkshopFetchError: showWorkshopFetchError,
    setLoading: setLoading,
    variantWrap: variantWrap,
    eventsPayloadScript: eventsPayloadScript,
    productHandle: productHandle,
    productGid: productGid,
    useLocationFirst: useLocationFirst,
    googleKeyEl: googleKeyEl,
    googleKey: googleKey,
    bookingBox: bookingBox,
    bookingHint: bookingHint,
    panelScopeRoot: panelScopeRoot,
    panelTitle: panelTitle,
    panelHintEl: panelHintEl,
    selectedSummary: selectedSummary,
    selectedEventIdInput: selectedEventIdInput,
    lastPriceEl: lastPriceEl,
    selectedItemsWrap: selectedItemsWrap,
    selectedItemsList: selectedItemsList,
    selectedItemsTotal: selectedItemsTotal,
    bookNowBtn: bookNowBtn,
    addToCartBtn: addToCartBtn,
    wbLockedVenueRefId: '',
    wbLockedVenueGroupKey: '',
    summaryVenue: summaryVenue,
    summaryVenueDetails: summaryVenueDetails,
    summaryDatetime: summaryDatetime,
    summaryCapacity: summaryCapacity,
    summaryStatus: summaryStatus,
    normalize: normalize,
    normKey: normKey,
    formatMoney: formatMoney,
    setLastPriceElDisplay: setLastPriceElDisplay,
    readJsonScriptInBooking: readJsonScriptInBooking,
    WB_PRICE_DEBUG: WB_PRICE_DEBUG,
    locationRules: locationRules,
    venueOverrides: venueOverrides,
    eventTimeOverrides: eventTimeOverrides,
    getSelections: getSelections,
    getSelectedVariantPriceCents: getSelectedVariantPriceCents,
    getSelectedVariantId: getSelectedVariantId,
    wstUpdate: wstUpdate,
    wstFormatDateKey: wstFormatDateKey,
    wstValues: wstValues,
    wstValuesWithQty: wstValuesWithQty,
    wstGetVariantNameFromButton: wstGetVariantNameFromButton,
    wstGetActiveVariantName: wstGetActiveVariantName,
    wstGetCurrentBookingFacts: wstGetCurrentBookingFacts,
    normalizeEventIdForMatch: normalizeEventIdForMatch,
    extractNumericEventIdForUrl: extractNumericEventIdForUrl,
    getEventIdFromUrl: getEventIdFromUrl,
    updateUrlForEventId: updateUrlForEventId,
    __wbPricing: __wbPricing,
    resolvePriceCents: resolvePriceCents,
    diagnosticRun: diagnosticRun,
    updateSelectedEventPrices: updateSelectedEventPrices,
    setLastPriceFromVariant: setLastPriceFromVariant,
    updateAllVariantCardPrices: updateAllVariantCardPrices,
    parseVariantIdFromGid: parseVariantIdFromGid,
    motionTriggerVariantById: motionTriggerVariantById,
    pickCapacityFields: pickCapacityFields,
    getRemainingCapacityFromCard: getRemainingCapacityFromCard,
    wbRenderCapacityBadge: wbRenderCapacityBadge,
    wbOpenStickyPanel: wbOpenStickyPanel,
    validateSeatSelection: validateSeatSelection,
    showPreviewPrice: showPreviewPrice,
    buildSelectionDetailFromCard: buildSelectionDetailFromCard,
    wbDispatchSelection: wbDispatchSelection,
    wbApplyEventsStepHeading: wbApplyEventsStepHeading,
    wbGetFirstBookableVenueCardInOpenGroup: wbGetFirstBookableVenueCardInOpenGroup,
    wbLockVenueContextFromCard: wbLockVenueContextFromCard,
    wbRestoreVenueContext: wbRestoreVenueContext,
    wbRefreshBookingGuideUi: wbRefreshBookingGuideUi,
    clearEventSelection: clearEventSelection,
    getAvailableVariantIdsFromCard: getAvailableVariantIdsFromCard,
    applyVariantCardVisibility: applyVariantCardVisibility,
    ensureVariantUiSyncedFromSelect: ensureVariantUiSyncedFromSelect,
    showSoldOutItemWarning: showSoldOutItemWarning,
    setEventSelectionFromCard: setEventSelectionFromCard,
    syncInCardSummaryForVenueCard: syncInCardSummaryForVenueCard,
    applyFilters: applyFilters,
    sortVisibleByStartsAt: sortVisibleByStartsAt,
    allEventsPayload: allEventsPayload,
    wbInitEventStatusLookup: wbInitEventStatusLookup,
    setWbState: setWbState,
    getWbState: function () { return wbState; },
    getLatLngFromPlace: getLatLngFromPlace,
    getCityStateFromPlace: getCityStateFromPlace,
    startPlaceInputWatcher: null
  };
  if (useLocationFirst) {
    if (!window.WorkshopBookingLocation || typeof window.WorkshopBookingLocation.attach !== "function") {
      console.error('[WB] workshop-booking-location.js missing');
    } else {
      window.WorkshopBookingLocation.attach(__wbScope);
    }
  }

  if (!window.WorkshopBookingCart || typeof window.WorkshopBookingCart.attach !== "function") {
    console.error('[WB] workshop-booking-cart.js missing');
  } else {
    window.WorkshopBookingCart.attach(__wbScope);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  wbMountAogenFormsBlockRetry(20, 300);
  initWorkshopBooking();
});
document.addEventListener('shopify:section:load', initWorkshopBooking);
document.addEventListener('shopify:section:reorder', initWorkshopBooking);
document.addEventListener('shopify:section:select', initWorkshopBooking);
